export default {
  "nav_signin": "Se connecter",
  "nav_account": "Compte",
  "nav_signout": "Déconnexion",
  "hero_title": "Solutions Numériques Intelligentes",
  "hero_title_line1": "Infinity Business — Solutions",
  "hero_title_line2": "Numériques Intelligentes",
  "hero_subtitle": "Découvrez RisTA, votre partenaire numérique intelligent",
  "hero_cta": "Parler à RisTA",
  "hero_cta2": "Voir les services",
  "b2b_title": "Solutions Entreprise (B2B)",
  "p2p_title": "Solutions Personnelles (P2P)",
  "b2b_desc": "Web, mobile, logiciel, hébergement, design et publicité",
  "p2p_desc": "Formation crypto, outils d'investissement, organisation, traduction, branding, domaines",
  "services_title": "Nos Services",
  "services_subtitle": "Des solutions web professionnelles aux outils d'investissement. RisTA vous guide.",
  "cta_title": "Prêt à créer quelque chose d'incroyable ?",
  "cta_subtitle": "Parlez à RisTA pour obtenir un devis personnalisé en quelques minutes.",
  "about": "À propos",
  "contact": "Contact",
  "privacy": "Confidentialité",
  "blog": "Blog",
  "donate": "Faire un don",
  "booking": "Réserver une session",
  "login_title": "Bon retour",
  "register_title": "Créer un compte",
  "login_subtitle": "Connectez-vous à votre compte Infinity Business",
  "register_subtitle": "Rejoignez Infinity Business aujourd'hui",
  "auth0_btn": "Continuer avec Auth0",
  "or_email": "ou continuer avec email",
  "email": "Adresse e-mail",
  "password": "Mot de passe",
  "full_name": "Nom complet",
  "signin_btn": "Se connecter",
  "register_btn": "Créer un compte",
  "no_account": "Pas de compte ?",
  "have_account": "Déjà un compte ?",
  "create_one": "Créer un",
  "sign_in": "Se connecter",
  "pricing_title": "Choisissez votre forfait",
  "pricing_subtitle": "Tous les forfaits incluent l'accès à RisTA.",
  "pay_stripe": "Payer avec Stripe",
  "pay_mypos": "Payer avec myPOS",
  "pay_crypto": "Payer en Crypto",
  "free_plan": "Forfait gratuit actuel",
  "most_popular": "Le plus populaire",
  "dashboard_title": "Mon compte",
  "profile": "Profil",
  "security": "Sécurité (2FA)",
  "subscription": "Abonnement",
  "upgrade": "Améliorer",
  "change_plan": "Changer de forfait",
  "twofa_title": "Authentification à deux facteurs",
  "setup_2fa": "Configurer 2FA",
  "disable_2fa": "Désactiver 2FA",
  "payment_success": "Paiement réussi !",
  "payment_cancel": "Paiement annulé",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Tous droits réservés.",
  "about_title": "À propos d'Infinity Business",
  "contact_title": "Contactez-nous",
  "privacy_title": "Politique de confidentialité",
  "send_message": "Envoyer le message",
  "trade_title": "Nous tradons pour vous",
  "trade_desc": "Services professionnels de trading crypto. Discutez avec nous.",
  "back_home": "Retour à l'accueil",
  "loading": "Chargement...",
  "save": "Enregistrer",
  "session_expired": "Votre session a expiré. Veuillez vous reconnecter.",
  "nav_services": "Services",
  "nav_portal": "Portail",
  "nav_credits": "Crédits",
  "hero_online": "En ligne",
  "hero_digital_partner": "Partenaire numérique",
  "business_solutions": "Solutions entreprise",
  "personal_solutions": "Solutions personnelles",
  "enterprise_desc": "Services numériques professionnels pour la croissance de votre entreprise.",
  "personal_desc": "Outils d'investissement et formation pour la croissance personnelle.",
  "services_hero_title": "Nos services",
  "services_hero_desc": "Des sites web aux solutions IA avancées. Nous livrons l'excellence numérique.",
  "get_started": "Commencer",
  "get_a_quote": "Obtenir un devis",
  "free_seo_audit": "Audit SEO gratuit",
  "ready_to_start": "Prêt à commencer ?",
  "ready_to_build": "Prêt à créer quelque chose d'incroyable ?",
  "ready_to_build_sub": "Parlez à RisTA pour un devis personnalisé.",
  "trusted_worldwide": "Confiance mondiale",
  "chat_placeholder": "Tapez votre message...",
  "chat_suggested_1": "J'ai besoin d'un site web",
  "chat_suggested_2": "Parlez-moi des services",
  "chat_suggested_3": "Je veux un service intelligent",
  "chat_suggested_4": "Obtenir un devis",
  "trust_platform": "Plateforme fiable",
  "trust_security": "Sécurité entreprise",
  "trust_ai": "Technologie Intelligente",
  "trust_global": "Portée mondiale",
  "back_to_home": "Retour à l\'accueil",
  "continue_google": "Continuer avec Google",
  "continue_facebook": "Continuer avec Facebook",
  "continue_github": "Continuer avec GitHub",
  "or_continue_email": "ou continuer avec email",
  "two_factor_auth": "Authentification à deux facteurs",
  "enter_2fa_code": "Entrez le code de votre application d\'authentification",
  "verify_btn": "Vérifier le code",
  "verifying": "Vérification...",
  "use_different_account": "Utiliser un autre compte",
  "session_expired_msg": "Votre session a expiré pour cause d\'inactivité.",
  "nav_home": "Accueil",
  "nav_back": "Retour",
  "my_account": "Mon compte",
  "sign_out": "Déconnexion",
  "client_portal": "Portail client",
  "your_projects": "Vos projets",
  "your_invoices": "Vos factures",
  "projects": "Projets",
  "invoices_tab": "Factures",
  "milestones": "Jalons",
  "messages": "Messages",
  "no_projects": "Pas encore de projets.",
  "no_invoices": "Pas encore de factures.",
  "no_messages": "Pas encore de messages.",
  "type_message": "Tapez un message...",
  "back_to_projects": "Retour aux projets",
  "budget_label": "Budget",
  "progress_label": "Progrès",
  "service_label": "Service",
  "portal_locked_desc": "Le portail est réservé aux clients approuvés.",
  "contact_to_start": "Contactez-nous",
  "quick_web_dev": "Développement web",
  "quick_mobile": "App mobile",
  "quick_crypto": "Éducation crypto",
  "quick_get_quote": "Obtenir un devis",
  "quick_tell_more": "En savoir plus",
  "quick_have_project": "J\'ai un projet",
  "quick_submit": "Envoyer la demande",
  "get_cost_estimate": "Estimation des coûts",
  "choose_plan": "Choisissez votre plan",
  "choose_plan_desc": "Développez votre entreprise avec le bon plan.",
  "current_free_plan": "Plan gratuit actuel",
  "svc_ecommerce_label": "E-Commerce / Boutique en ligne",
  "svc_ecommerce_desc": "Boutiques en ligne complètes avec intégration de paiement",
  "svc_seo_label": "SEO et marketing digital",
  "svc_seo_desc": "Optimisation pour les moteurs de recherche et stratégie de croissance",
  "svc_hosting_label": "Hébergement géré",
  "svc_hosting_desc": "Infrastructure d\'hébergement sécurisée, rapide et fiable",
  "svc_advertising_label": "Publicité digitale",
  "svc_advertising_desc": "PPC, publicités sociales et marketing de performance",
  "svc_trading_label": "Consultation trading",
  "svc_trading_desc": "Sessions de stratégie de trading guidées par des experts",
  "svc_domains_label": "Gestion de domaines",
  "svc_domains_desc": "Enregistrement de domaines, gestion DNS et transferts",
  "svc_ecommerce_price": "À partir de €799",
  "svc_seo_price": "À partir de €299/mois",
  "svc_hosting_price": "À partir de €29/mois",
  "svc_advertising_price": "À partir de €499/mois",
  "svc_trading_price": "À partir de €149/séance",
  "svc_domains_price": "À partir de €19/an",
  "testimonials_title": "Ce que disent nos clients",
  "testimonials_subtitle": "Des entreprises à travers l'Europe nous font confiance",
  "stat_projects": "Projets livrés",
  "stat_satisfaction": "Satisfaction client",
  "stat_languages": "Langues supportées",
  "all_rights_reserved": "Tous droits réservés.",
  "form_your_name": "Votre nom",
  "form_your_email": "Votre email",
  "form_describe_need": "Décrivez vos besoins...",
  "form_additional_feedback": "Commentaires supplémentaires ? (optionnel)",
  "form_email_followup": "Votre email (optionnel, pour suivi)",
  "form_budget_range": "Fourchette de budget",
  "form_timeline": "Délai",
  "form_cancel": "Annuler",
  "form_select_services": "Sélectionnez les services (plusieurs possibles) :",
  "rating_title": "Évaluez votre expérience avec RisTA",
  "rating_helpful": "Cette conversation a-t-elle été utile ?",
  "rating_overall": "Expérience globale avec l\'assistant",
  "rating_recommend": "Recommanderiez-vous RisTA ?",
  "rating_yes": "Oui",
  "rating_no": "Non",
  "rating_submit": "Envoyer l\'évaluation",
  "rating_skip": "Passer",
  "rating_thanks": "Merci pour votre retour !",
  "generating_estimate": "Génération de l\'estimation...",
  "profile_info": "Informations du profil",
  "profile_name": "Nom",
  "profile_email": "Email",
  "profile_role": "Rôle",
  "profile_member_since": "Membre depuis",
  "profile_rerun_onboarding": "Relancer l\'introduction",
  "profile_language_pref": "Langue préférée",
  "profile_language_saved": "Préférence de langue enregistrée !",
  "privacy_heading": "Politique de confidentialité",
  "terms_heading": "Conditions générales",
  "about_heading": "À propos d\'Infinity Business",
  "walkthrough_heading": "Tutoriels",
  "estimate_title": "Estimation du coût",
  "estimate_service": "Service",
  "estimate_complexity": "Complexité",
  "estimate_base_price": "Prix de base",
  "estimate_cost": "Coût estimé",
  "estimate_features": "Fonctionnalités clés",
  "estimate_accept": "Accepter et soumettre",
  "estimate_revise": "Réviser",
  "submit_service_request": "Soumettre votre demande",
  "about_values": "Nos valeurs",
  "about_what_we_do": "Ce que nous faisons",
  "about_meet_rista": "Rencontrez RisTA",
  "about_talk_rista": "Parler à RisTA",
  "services_cta_title": "Prêt à commencer ?",
  "services_cta_desc": "Parlez à RisTA pour obtenir un devis personnalisé.",
  "services_talk_rista": "Parler à RisTA",
  "services_free_audit": "Audit SEO gratuit",
  "walkthrough_gmail": "Assistant Gmail IA",
  "walkthrough_gmail_desc": "Comment RisTA organise votre boîte mail",
  "walkthrough_calendar": "Conseiller personnel",
  "walkthrough_calendar_desc": "Calendrier, tâches et emails par chat",
  "walkthrough_ai": "Services IA",
  "walkthrough_ai_desc": "CV, plans d\'affaires, kits de marque et plus",
  "about_val_trust": "Confiance et sécurité",
  "about_val_trust_desc": "Nous appliquons les normes les plus élevées de protection des données.",
  "about_val_innovation": "Innovation",
  "about_val_innovation_desc": "La technologie IA de pointe pilote nos solutions.",
  "about_val_partnership": "Partenariat",
  "about_val_partnership_desc": "Nous travaillons à vos côtés en tant que vrai partenaire.",
  "about_val_global": "Portée mondiale",
  "about_val_global_desc": "Solutions conçues pour les marchés internationaux.",
  "about_svc_web": "Développement web",
  "about_svc_web_desc": "Applications web, plateformes e-commerce et solutions CMS.",
  "about_svc_mobile": "Applications mobiles",
  "about_svc_mobile_desc": "Apps natives et multiplateformes pour iOS et Android.",
  "about_svc_software": "Logiciel sur mesure",
  "about_svc_software_desc": "Solutions logicielles pour automatiser vos processus.",
  "about_svc_invest": "Investissements intelligents",
  "about_svc_invest_desc": "Outils crypto et DeFi avec services de trading.",
  "about_rista_desc": "RisTA est notre assistant IA intelligent, disponible 24/7, multilingue et adapté à vos besoins.",
  "privacy_last_updated": "Dernière mise à jour : 7 mars 2026",
  "privacy_intro": "Infinity Business (\"nous\"), exploité par Liber Nostra d.o.o., s\'engage à protéger votre vie privée.",
  "terms_last_updated": "Dernière mise à jour : février 2026",
  "nav_tools": "Outils",
  "nav_marketplace": "Marketplace",
  "chat_digital_partner": "Partenaire numérique",
  "chat_online": "En ligne",
  "chat_help_text": "Je peux aider avec le développement web, les apps mobiles, le design, la crypto et plus.",
  "chat_your_partner": "Votre partenaire numérique",
  "chat_assistant_subtitle": "Discutez avec votre assistant IA",
  "tab_password": "Mot de passe",
  "tab_rista_services": "Services RisTA",
  "tab_analytics": "Analytiques",
  "tab_projects": "Projets",
  "tab_referral": "Programme de parrainage",
  "marketplace_title": "Marketplace de modèles",
  "marketplace_subtitle": "Modèles premium personnalisables. Qualité professionnelle, prêts à l'emploi.",
  "marketplace_search": "Rechercher des modèles...",
  "marketplace_purchase": "Acheter",
  "marketplace_preview": "Aperçu",
  "marketplace_all": "Tous",
  "marketplace_category_website": "Site web",
  "marketplace_category_brand": "Marque",
  "marketplace_category_resume": "CV",
  "marketplace_downloads": "téléchargements",
  "marketplace_features": "Fonctionnalités",
  "case_studies_title": "Histoires de réussite",
  "case_studies_subtitle": "De vrais résultats pour de vraies entreprises. Voyez la transformation.",
  "case_studies_before": "Avant",
  "case_studies_after": "Après",
  "case_studies_cta_title": "Prêt à développer votre entreprise ?",
  "case_studies_cta_desc": "Rejoignez ces entreprises et obtenez des résultats similaires avec nos services IA.",
  "case_studies_cta_btn": "Commencer",
  "profile_go_homepage": "Aller à la page d'accueil",
  "onboarding_welcome_title": "Bienvenue chez Infinity Business",
  "onboarding_welcome_subtitle": "Votre partenaire numérique propulsé par l'IA",
  "onboarding_welcome_content": "Infinity Business offre des services numériques B2B et P2P. Notre assistant IA RisTA vous guidera.",
  "onboarding_welcome_item1": "Estimation de projets par IA",
  "onboarding_welcome_item2": "Services web, mobile et design",
  "onboarding_welcome_item3": "Éducation crypto et outils d'investissement",
  "onboarding_welcome_item4": "Consultations personnalisées",
  "onboarding_services_title": "Explorez nos services",
  "onboarding_services_subtitle": "Deux catégories adaptées pour vous",
  "onboarding_services_content": "Nous offrons deux catégories de services :",
  "onboarding_services_item1": "B2B : Développement web, apps mobiles, design graphique, hébergement, logiciel, publicité",
  "onboarding_services_item2": "P2P : Éducation crypto, outils d'investissement, trading, domaines, DeFi",
  "onboarding_services_item3": "Services IA : CV, business plan, rapports SEO, kits de marque et plus",
  "onboarding_services_item4": "Parlez à RisTA à tout moment pour un devis personnalisé",
  "onboarding_credits_title": "Système de crédits",
  "onboarding_credits_subtitle": "Solde prépayé pour les services IA",
  "onboarding_credits_content": "Utilisez les crédits pour un accès instantané à nos services IA :",
  "onboarding_credits_item1": "Rechargez votre solde à tout moment (min. 5, max. 1 000)",
  "onboarding_credits_item2": "Les crédits sont automatiquement déduits lors de l'utilisation des services IA",
  "onboarding_credits_item3": "Vous serez toujours invité à confirmer avant toute déduction",
  "onboarding_credits_item4": "Consultez votre solde et historique dans le panneau crédits",
  "onboarding_chat_title": "Parlez à RisTA",
  "onboarding_chat_subtitle": "Votre partenaire numérique est prêt",
  "onboarding_chat_content": "RisTA peut vous aider avec :",
  "onboarding_chat_item1": "Obtenir des estimations et devis de projets",
  "onboarding_chat_item2": "Explorer les options de services en détail",
  "onboarding_chat_item3": "Soumettre des demandes de service",
  "onboarding_chat_item4": "Répondre aux questions en 11 langues",
  "onboarding_next": "Suivant",
  "onboarding_get_started": "Commencer",
  "onboarding_back": "Retour",
  "onboarding_biz_title": "Sélection de services",
  "onboarding_biz_subtitle": "Qu'est-ce qui décrit le mieux vos besoins ?",
  "onboarding_biz_content": "Aidez-nous à recommander les bons services pour vous :",
  "onboarding_biz_type_startup": "Startup / Nouvelle entreprise",
  "onboarding_biz_type_smb": "PME",
  "onboarding_biz_type_enterprise": "Grande entreprise / Corporation",
  "onboarding_biz_type_freelancer": "Freelance / Particulier",
  "onboarding_biz_type_investor": "Investisseur / Passionné de crypto",
  "change_password_title": "Changer le mot de passe",
  "referral_title": "Programme de parrainage",
  "referral_generate": "Générer mon code de parrainage",
  "referral_redeem_title": "Utiliser un code",
  "referral_redeem_btn": "Utiliser",
  "referral_referrals": "Parrainages",
  "referral_rewards": "Récompenses",
  "referral_copy_link": "Copier le lien",
  "referral_copied": "Copié !",
  "project_tracker_title": "Suivi des projets",
  "project_no_projects": "Pas encore de projets. Les projets apparaîtront ici après l'achat d'un service.",
  "analytics_total_services": "Total des services",
  "analytics_completed": "Terminés",
  "analytics_pending": "En attente",
  "analytics_total_spent": "Total dépensé",
  "analytics_credit_balance": "Solde des crédits",
  "analytics_recent": "Services récents",
  "billing_manage_btn": "Gérer la facturation",
  "billing_cancel_btn": "Annuler le plan",
  "plan_features": "Fonctionnalités de votre plan",
  "nav_try_free": "Essai gratuit",
  "testimonial_1_text": "RisTA nous a aidés à construire toute notre présence web en seulement 2 semaines.",
  "testimonial_2_text": "Le kit de marque et le calendrier de réseaux sociaux nous ont fait économiser des mois de travail.",
  "testimonial_3_text": "J'utilise régulièrement le créateur de CV et les outils d'analyse. La qualité IA est excellente.",
  "tools_title": "Outils marketing gratuits",
  "tools_subtitle": "Essayez nos outils gratuits - sans inscription",
  "sp_basic_web_name": "Création de site web basique",
  "sp_basic_web_desc": "Site web professionnel pour votre entreprise avec un design moderne et une compatibilité mobile complète.",
  "sp_basic_web_feat": "Design responsive moderne|Jusqu'à 5 pages|Intégration formulaire de contact|Optimisé mobile|Configuration SEO de base|Aide à la saisie de contenu",
  "sp_web_store_name": "Boutique en ligne / E-Commerce",
  "sp_web_store_desc": "Plateforme e-commerce complète avec paiements intégrés et outils marketing.",
  "sp_web_store_feat": "Boutique en ligne complète|Traitement des paiements|Gestion des produits|Suivi des commandes|Optimisation SEO|Stratégie marketing incluse",
  "sp_custom_web_name": "Application web sur mesure",
  "sp_custom_web_desc": "Applications web adaptées à vos besoins professionnels exacts.",
  "sp_custom_web_feat": "Design logiciel sur mesure|Intégrations API|Architecture de base de données|Infrastructure évolutive|Tableaux de bord admin|Support continu",
  "sp_mobile_app_name": "Application mobile",
  "sp_mobile_app_desc": "Applications mobiles natives et cross-platform pour iOS et Android.",
  "sp_mobile_app_feat": "iOS et Android|Développement cross-platform|Notifications push|Soumission app store|Design UI/UX|Intégration backend",
  "sp_seo_name": "SEO et marketing digital",
  "sp_seo_desc": "Augmentez votre visibilité en ligne avec des stratégies SEO et marketing digital complètes.",
  "sp_seo_feat": "Audit SEO complet|Optimisation des mots-clés|Stratégie de contenu|Gestion Google Ads|Marketing réseaux sociaux|Rapports mensuels",
  "sp_graphic_name": "Design graphique et branding",
  "sp_graphic_desc": "Solutions complètes de branding et design graphique pour votre identité d'entreprise.",
  "sp_graphic_feat": "Design de logo|Identité de marque|Supports marketing|Visuels réseaux sociaux|Design print|Guide de style",
  "sp_crypto_edu_name": "Programme d'éducation crypto",
  "sp_crypto_edu_desc": "Apprenez le trading de cryptomonnaies et la technologie blockchain avec des experts.",
  "sp_crypto_edu_feat": "Fondamentaux blockchain|Stratégies de trading|Sécurité des portefeuilles|Introduction DeFi|Analyse de marché|Mentorat personnel",
  "sp_invest_name": "Outils d'investissement intelligents",
  "sp_invest_desc": "Outils professionnels de suivi et d'analyse d'investissement propulsés par l'IA.",
  "sp_invest_feat": "Suivi de portefeuille|Tableau de bord marché|Analyses IA|Évaluation des risques|Alertes en temps réel|Support multi-bourses",
  "sp_ad_name": "Services publicitaires",
  "sp_ad_desc": "Atteignez des millions via notre vaste réseau de portails dans plusieurs régions.",
  "sp_ad_feat": "Réseau de 20+ portails|10M+ de portée|Campagnes ciblées|Suivi des performances|Annonces multi-plateformes|Optimisation ROI",
  "contact_heading": "Nous contacter",
  "contact_subtitle_text": "Vous avez une question ou souhaitez discuter d'un projet ? Nous serions ravis de vous entendre.",
  "contact_name_label": "Nom",
  "contact_email_label": "Email",
  "contact_subject_label": "Sujet",
  "contact_message_label": "Message",
  "contact_name_ph": "Votre nom",
  "contact_email_ph": "vous@exemple.com",
  "contact_subject_ph": "De quoi s'agit-il ?",
  "contact_message_ph": "Parlez-nous de votre projet ou question...",
  "contact_send_btn": "Envoyer le message",
  "contact_sending": "Envoi en cours...",
  "contact_sent_title": "Message envoyé !",
  "contact_sent_msg": "Merci de nous avoir contactés. Nous vous répondrons dans les 24 heures.",
  "contact_send_another": "Envoyer un autre message",
  "contact_info_email": "Email",
  "contact_info_location": "Localisation",
  "contact_info_eu": "Union européenne",
  "contact_info_response": "Délai de réponse",
  "contact_info_response_time": "Sous 24 heures",
  "contact_info_hours": "Lun - Ven, 9h00 - 18h00 CET",
  "tf_seo_name": "Audit SEO gratuit",
  "tf_seo_desc": "Obtenez une analyse SEO complète de n'importe quel site - sans inscription.",
  "tf_color_name": "Générateur de palette de couleurs",
  "tf_color_desc": "Générez de belles palettes de couleurs harmonieuses pour votre marque.",
  "tf_headline_name": "Analyseur de titres",
  "tf_headline_desc": "Évaluez vos titres pour le potentiel de clic et l'impact émotionnel.",
  "tf_chat_name": "Discuter avec RisTA",
  "tf_chat_desc": "Obtenez des estimations de projet instantanées et explorez les services en 11 langues.",
  "tf_free_label": "Gratuit",
  "tools_seo_title": "Vérification SEO rapide",
  "tools_seo_desc": "Score SEO instantané pour n'importe quel site",
  "tools_seo_ph": "Entrez l'URL du site (ex. exemple.com)",
  "tools_analyze": "Analyser",
  "tools_color_title": "Générateur de palette de couleurs",
  "tools_color_desc": "Générez des palettes de couleurs complémentaires",
  "tools_headline_title": "Analyseur de titres",
  "tools_headline_desc": "Analysez l'efficacité des titres",
  "tools_headline_ph": "Entrez votre titre...",
  "tools_headline_btn": "Analyser le titre",
  "tools_issues": "Problèmes trouvés",
  "tools_suggestions": "Suggestions",
  "tools_score": "Score",
  "docs_heading": "Fonctionnalités de la plateforme",
  "docs_subtitle": "Tout ce qu'Infinity Business offre pour votre parcours digital.",
  "docs_no_data": "Aucune documentation disponible.",
  "tester_heading": "Devenir testeur",
  "tester_subtitle": "Aidez-nous à améliorer la plateforme et obtenez un accès gratuit aux services.",
  "tester_req_title": "Ce qui est requis",
  "tester_req_1": "Se connecter au moins 5 fois par semaine",
  "tester_req_2": "Soumettre au moins 10 rapports de bugs/retours par semaine",
  "tester_req_3": "Tester différentes fonctionnalités, pages et flux utilisateurs",
  "tester_benefit_title": "Ce que vous obtenez",
  "tester_benefit_1": "Accès gratuit aux services du système intelligent (sur demande)",
  "tester_benefit_2": "Tableau de bord testeur avec suivi de progression",
  "tester_benefit_3": "Support prioritaire de l'équipe",
  "tester_apply_title": "Postuler",
  "tester_motivation": "Pourquoi souhaitez-vous être testeur ?",
  "tester_motivation_ph": "Dites-nous pourquoi vous aimeriez aider à tester la plateforme...",
  "tester_experience": "Expérience de test (optionnel)",
  "tester_experience_ph": "Toute expérience pertinente...",
  "tester_submit_app": "Soumettre la candidature",
  "tester_applied_title": "Candidature soumise",
  "tester_applied_msg": "Notre admin examinera votre candidature et vous serez notifié.",
  "tester_need_account": "Vous avez besoin d'un compte pour postuler.",
  "tester_dash_title": "Tableau de bord testeur",
  "tester_dash_desc": "Maintenez votre statut de testeur en atteignant les objectifs hebdomadaires.",
  "tester_weekly_logins": "Connexions hebdomadaires",
  "tester_weekly_reports": "Rapports hebdomadaires",
  "tester_target_met": "Objectif atteint !",
  "tester_logins_needed": "connexions supplémentaires nécessaires cette semaine",
  "tester_reports_needed": "rapports supplémentaires nécessaires cette semaine",
  "tester_total_reports": "Total des rapports soumis",
  "tester_on_track": "En bonne voie",
  "tester_at_risk": "À risque",
  "tester_report_heading": "Soumettre un rapport de bug / retour",
  "tester_report_title_ph": "Titre (ex. 'Bouton non cliquable sur mobile')",
  "tester_report_desc_ph": "Décrivez le problème ou la suggestion en détail...",
  "tester_report_page_ph": "URL de la page (optionnel)",
  "tester_submit_report": "Soumettre le rapport",
  "seo_page_title": "Audit SEO gratuit",
  "seo_page_desc": "Entrez l'URL d'un site pour une analyse SEO complète avec recommandations.",
  "seo_page_ph": "Entrez l'URL du site (ex. exemple.com)",
  "seo_page_btn": "Lancer l'audit",
  "seo_page_running": "Analyse en cours...",
  "seo_page_error": "Impossible d'analyser ce site. Vérifiez l'URL et réessayez.",
  "referral_reward_title": "Comment fonctionnent les récompenses",
  "referral_reward_desc": "Gagnez 10% de chaque achat effectué par les utilisateurs que vous parrainez, crédités automatiquement sur votre compte.",
  "referral_reward_1": "Partagez votre lien de parrainage unique avec vos amis",
  "referral_reward_2": "Quand ils effectuent un achat, vous gagnez 10% en crédits gratuits",
  "referral_reward_3": "Les crédits sont ajoutés automatiquement à votre solde",
  "referral_earned_label": "Crédits gagnés",
  "profile_picture": "Photo de profil",
  "profile_bio": "Biographie",
  "profile_website": "Site web",
  "profile_interests": "Centres d'intérêt",
  "profile_upload_photo": "Télécharger une photo",
  "profile_bio_ph": "Parlez-nous de vous...",
  "profile_website_ph": "https://votresite.com",
  "profile_interests_ph": "ex. Développement web, Crypto, IA",
  "profile_save": "Enregistrer le profil",
  "admin_notes": "Notes admin",
  "admin_notes_ph": "Ajouter une note sur cet utilisateur...",
  "admin_notes_add": "Ajouter une note",
  "sub_most_popular": "Le plus populaire",
  "sub_free": "Gratuit",
  "sub_one_time": "paiement unique",
  "sub_team_members": "Membres de l'équipe",
  "sub_members_info": "Invitez des membres de l'équipe à partager votre plan. Chaque membre obtient son propre identifiant et accès aux services.",
  "sub_show_less": "Afficher moins",
  "sub_more_features": "fonctionnalités supplémentaires",
  "sub_pay_with": "Payer avec",
  "sub_preferred": "préféré",
  "sub_live_crypto": "Prix crypto en direct (EUR et USD)",
  "sp_logo_name": "Création de Logo",
  "sp_logo_desc": "Création de logo professionnel qui capture l'essence de votre marque.",
  "sp_logo_feat": "3 concepts uniques|Révisions illimitées|Fichiers vectoriels|Couleur + N&B|Guide de marque|Kit réseaux sociaux",
  "sp_brand_name": "Identité de Marque Complète",
  "sp_brand_desc": "Package complet d'identité de marque avec logo, palette et guidelines.",
  "sp_brand_feat": "Logo|Palette de couleurs|Typographie|Carte de visite|En-tête|PDF guidelines|Templates réseaux",
  "sp_poster_name": "Design d'Affiche",
  "sp_poster_desc": "Designs d'affiches accrocheurs pour événements et campagnes.",
  "sp_poster_feat": "Illustration personnalisée|Fichiers prêts à imprimer|Plusieurs tailles|2 tours de révision|Haute résolution|Digital + print",
  "sp_flyer_name": "Design de Flyer",
  "sp_flyer_desc": "Designs de flyers professionnels pour marketing et événements.",
  "sp_flyer_feat": "Recto & verso|PDF prêt à imprimer|Version digitale|Code QR|2 révisions|Plusieurs formats",
  "sp_menu_name": "Design de Menu",
  "sp_menu_desc": "Beaux designs de menu pour restaurants et cafés.",
  "sp_menu_feat": "Mise en page personnalisée|Photos intégrées|Version QR|Fichiers print|Mise à jour saisonnière|Plusieurs pages",
  "currency_label": "Devise",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Nous sommes une entreprise technologique axée sur les solutions numériques intelligentes. Fondée en 2026, Infinity Business allie innovation IA et expertise éprouvée pour aider les entreprises et les individus à prospérer dans l'économie numérique.",
  "micro_tools_title": "Micro-outils intelligents",
  "micro_tools_subtitle": "Informations instantanées par IA pour la génération de leads et la planification stratégique.",
  "micro_tools_all": "Tous",
  "micro_tools_try": "Essayer",
  "micro_tools_generate_free": "Générer (Gratuit)",
  "micro_tools_generate_paid": "Générer",
  "micro_tools_close": "Fermer",
  "micro_tools_interested": "Intéressé ?",
  "tools_view_service": "Voir le service",
  "tools_talk_rista": "Parler à RisTA",
  "competitor_title": "Analyse concurrentielle IA",
  "competitor_desc": "Entrez l'URL d'un concurrent pour une analyse IA avec comparaison SEO et évaluation du design.",
  "competitor_url_ph": "Entrez l'URL du concurrent",
  "competitor_analyze": "Analyser le concurrent",
  "competitor_score": "Score global",
  "competitor_seo": "Analyse SEO",
  "competitor_design": "Analyse du design",
  "competitor_content": "Analyse du contenu",
  "competitor_strengths": "Points forts",
  "competitor_weaknesses": "Faiblesses",
  "competitor_opportunities": "Opportunités",
  "competitor_recommendations": "Recommandations",
  "accessibility_title": "Vérification d'accessibilité",
  "accessibility_desc": "Vérifier la conformité aux normes d'accessibilité",
  "cat_lead_gen": "Génération de leads",
  "cat_discovery": "Découverte de rapports",
  "cat_email": "Email et workflow",
  "cat_planning": "Planification et stratégie",
  "cat_content": "Contenu et positionnement",
  "sp_tools_title": "Micro-services Intelligents",
  "sp_tools_desc": "Services intelligents instantanés pour le contenu, la marque et l'analyse.",
  "sp_free_title": "Outils Gratuits",
  "sp_free_desc": "Essayez notre plateforme avec ces outils gratuits.",
  "a11y_checker": "Vérification de l'accessibilité",
  "a11y_compliant": "Conforme",
  "a11y_disclaimer": "Les vérifications automatiques couvrent ~30% des problèmes d'accessibilité. Des tests manuels avec des lecteurs d'écran sont recommandés.",
  "a11y_error": "L'audit a échoué. Veuillez réessayer.",
  "a11y_incomplete": "nécessite un examen",
  "a11y_issues_found": "Problèmes trouvés",
  "a11y_no_issues": "Aucun problème d'accessibilité trouvé !",
  "a11y_passed": "réussi",
  "a11y_rescan": "Rescanner",
  "a11y_scanning": "Exécution de l'audit WCAG...",
  "a11y_violations": "violations",
  "admin_ab_testing": "Tests A/B",
  "admin_account_mgmt": "Gestion des comptes",
  "admin_actions": "Actions",
  "admin_active": "Actif",
  "admin_ad_gen": "Générateur de publicités",
  "admin_add_milestone": "Ajouter un jalon",
  "admin_adv_reports": "Rapports avancés",
  "admin_ai_config": "Configuration du modèle",
  "admin_ai_prompts": "Prompts intelligents",
  "admin_analytics": "Analytique",
  "admin_audit": "Audit de la plateforme",
  "admin_audit_trail": "Piste d'audit",
  "admin_auto_posting": "Publication automatique intelligente",
  "admin_avatar_builder": "Créateur d'avatar",
  "admin_avatar_selector": "Sélecteur d'avatar",
  "admin_avg_exp": "Exp. moyenne",
  "admin_avg_rating": "Note moyenne",
  "admin_backup": "Sauvegarde et restauration",
  "admin_billing": "Facturation récurrente",
  "admin_blog": "Gestionnaire de blog",
  "admin_bug_reports": "Rapports de bugs",
  "admin_cancel": "Annuler",
  "admin_cdn": "Gestionnaire CDN",
  "admin_chat_analytics": "Analytique du chat",
  "admin_chat_sessions": "Sessions de chat",
  "admin_client_portal": "Portail client",
  "admin_abandoned_carts": "Paniers abandonnés",
  "rista_login_required": "Connexion requise",
  "rista_login_desc": "Connectez-vous ou créez un compte pour discuter avec RisTA et obtenir des recommandations commerciales personnalisées.",
  "rista_login_btn": "Se connecter",
  "rista_signup_btn": "S'inscrire",
  "admin_created": "Créé",
  "admin_credits": "Configuration des crédits",
  "admin_crypto_payments": "Paiements crypto",
  "admin_crypto_trading": "Trading crypto",
  "admin_currency": "Multi-devise",
  "admin_defi": "Éléments DeFi",
  "admin_delete": "Supprimer",
  "admin_demo": "Accès démo",
  "admin_demo_banner": "MODE LECTURE SEULE - Compte de démonstration (Toutes les données sont masquées)",
  "admin_docs": "Documentation",
  "admin_domain": "Gestionnaire de domaines",
  "admin_edit": "Modifier",
  "admin_email_builder": "Constructeur d'e-mails",
  "admin_email_templates": "Modèles d'e-mails",
  "admin_email_templates_desc": "Personnalisez les modèles d'e-mails avec l'éditeur visuel de blocs.",
  "admin_escalations": "Escalades de chat",
  "admin_fb": "Analytique FB",
  "admin_followups": "E-mails de suivi",
  "admin_health": "Moniteur de santé",
  "admin_health_monitor": "Surveillance de santé",
  "admin_health_score": "Score de santé",
  "admin_high_leads": "Leads prioritaires",
  "admin_high_value": "Leads à haute valeur",
  "admin_image_gen": "Génération d'images",
  "admin_integrations": "Intégrations",
  "admin_invoices": "Facturation",
  "admin_kb": "Base de connaissances",
  "admin_language_requests": "Demandes de langues",
  "admin_lead_tracking": "Suivi des leads",
  "admin_live_analytics": "Analytique en direct",
  "admin_loading": "Chargement...",
  "admin_logo": "Logo et favicon",
  "admin_milestone_desc": "Description (optionnel)",
  "admin_milestone_title": "Titre du jalon",
  "admin_my_account": "Mon compte",
  "admin_new": "nouveau",
  "admin_no_data": "Aucune donnée disponible",
  "admin_no_matching": "Aucun onglet correspondant",
  "admin_no_milestones": "Pas encore de jalons. Ajoutez le premier !",
  "admin_notifications": "Notifications",
  "admin_out_of": "Sur",
  "admin_overview": "Vue d'ensemble",
  "admin_panel": "Panneau d'administration",
  "admin_payment_opts": "Options de paiement",
  "admin_pending": "En attente",
  "admin_portfolio": "Gestionnaire de portfolio",
  "admin_preloader": "Configuration du préchargeur",
  "admin_pricing": "Tarification dynamique",
  "admin_promo": "Codes promo",
  "admin_rate_limiting": "Limitation de débit",
  "admin_rbac": "Contrôle d'accès",
  "admin_referral_board": "Classement des parrainages",
  "admin_referrals": "Programme de parrainage",
  "admin_reports": "Rapports admin",
  "admin_requests": "Demandes de services",
  "admin_reviews": "avis",
  "admin_rista": "Services RisTA",
  "admin_save": "Enregistrer",
  "admin_score": "Score",
  "admin_search_tabs": "Rechercher des onglets...",
  "admin_sendgrid": "E-mail (SendGrid)",
  "admin_service_mgr": "Gestionnaire de services",
  "admin_sign_out": "Déconnexion",
  "admin_social": "Réseaux sociaux",
  "admin_social_auto": "Automatisation sociale",
  "admin_social_icons": "Icônes sociales",
  "admin_status": "Statut",
  "admin_surveys": "Enquêtes de satisfaction",
  "admin_system_admin": "ADMINISTRATEUR SYSTÈME",
  "admin_system_config": "Configuration système",
  "admin_tester": "Programme de testeurs",
  "admin_timeline": "Chronologie du projet",
  "admin_total": "Total",
  "admin_ui_toggles": "Bascules UI",
  "admin_unread": "Non lu",
  "admin_updated": "Mis à jour",
  "admin_users": "Gestion des utilisateurs",
  "admin_view_all": "Tout voir",
  "billing_manage_desc": "Gérez vos méthodes de paiement, consultez les factures ou mettez à jour vos informations de facturation via le portail Stripe.",
  "billing_management": "Gestion de la facturation",
  "change_password_btn": "Changer le mot de passe",
  "change_password_confirm": "Confirmer le nouveau mot de passe",
  "change_password_current": "Mot de passe actuel",
  "change_password_new": "Nouveau mot de passe",
  "change_password_social": "Le changement de mot de passe n'est pas disponible pour les comptes de connexion sociale.",
  "health_a11y": "Accessibilité",
  "health_desc": "Analyse complète du SEO, des performances, de la sécurité et de l'accessibilité de votre site web.",
  "health_history": "Historique des scans",
  "health_login_desc": "Créez un compte gratuit pour scanner votre site et suivre les améliorations.",
  "health_login_required": "Connectez-vous pour utiliser le score de santé",
  "health_overall": "Score de santé global",
  "health_perf": "Performance",
  "health_premium_badge": "Fonctionnalité Premium",
  "health_response": "Réponse",
  "health_scan_btn": "Scanner",
  "health_scan_error": "Échec du scan. Veuillez vérifier l'URL.",
  "health_scanning": "Scan en cours...",
  "health_security": "Sécurité",
  "health_seo": "SEO",
  "health_size": "Taille",
  "health_title": "Score de santé du site web",
  "health_upgrade_btn": "Passer à Premium",
  "health_upsell_desc": "Passez à Premium pour des scans automatiques, des alertes e-mail et le suivi des tendances.",
  "health_upsell_title": "Surveillance récurrente souhaitée ?",
  "health_url_ph": "Entrez l'URL du site (ex: example.com)",
  "nav_currency": "Devise",
  "nav_health_score": "Score de santé",
  "nav_orders": "Mes commandes",
  "priority_critical": "Critique",
  "priority_high": "Élevée",
  "priority_low": "Basse",
  "priority_medium": "Moyenne",
  "profile_about": "À propos de vous",
  "profile_appearance": "Apparence et accessibilité",
  "profile_change_avatar": "Changer l'avatar",
  "profile_country": "Pays",
  "profile_country_ph": "ex: France, Belgique, Suisse",
  "profile_interests_hint": "Séparez les intérêts par des virgules",
  "profile_text_size": "Taille du texte",
  "profile_text_size_hint": "Ajustez la taille du texte pour une meilleure lisibilité.",
  "profile_theme": "Thème",
  "seo_cta_desc": "Notre audit SEO intelligent couvre 100+ points de contrôle. Obtenez de l'aide professionnelle.",
  "seo_cta_title": "Besoin d'aide avec ces problèmes ?",
  "sp_biz_plan_desc": "Générez un business plan complet avec finances, analyse de marché et stratégie de croissance.",
  "sp_biz_plan_feat": "Résumé exécutif|Analyse de marché|Projections financières|Aperçu concurrentiel|Stratégie de croissance|Format investisseur",
  "sp_biz_plan_name": "Business Plan intelligent",
  "sp_brand_kit_desc": "Package complet d'identité de marque avec concepts de logo, palette de couleurs et assets sociaux.",
  "sp_brand_kit_feat": "Concepts de logo|Palette de couleurs|Typographie|Assets réseaux sociaux|Directives de marque|Set d'icônes",
  "sp_brand_kit_name": "Logo et kit de marque intelligent",
  "sp_competitor_desc": "Intelligence concurrentielle approfondie avec comparaison SEO et analyse des lacunes de contenu.",
  "sp_competitor_feat": "Comparaison SEO|Revue design|Lacunes de contenu|Positionnement marché|Analyse SWOT|Recommandations stratégiques",
  "sp_competitor_name": "Analyse concurrentielle",
  "sp_email_campaign_desc": "Configuration professionnelle de campagne e-mail avec texte, séquences et ciblage.",
  "sp_email_campaign_feat": "Rédaction e-mail|Configuration séquences|Ciblage audience|Tests A/B|Configuration analytics|Design modèle",
  "sp_email_campaign_name": "Configuration e-mail marketing",
  "sp_free_seo_desc": "Lancez un audit SEO gratuit sur n'importe quel site pour découvrir des opportunités d'optimisation.",
  "sp_free_seo_feat": "Résultats instantanés|100+ vérifications|Score performance|Vérification mobile|Scan sécurité|Rapport gratuit",
  "sp_free_seo_name": "Audit SEO gratuit",
  "sp_free_tools_desc": "Accédez à notre collection d'outils gratuits incluant palettes de couleurs et analyseurs de titres.",
  "sp_free_tools_feat": "Générateur de palettes|Analyseur de titres|Générateur de mots de passe|Créateur QR code|Convertisseur d'unités|Sans inscription",
  "sp_free_tools_name": "Outils numériques gratuits",
  "sp_health_score": "Score de santé du site web",
  "sp_health_score_desc": "Analyse complète du site couvrant SEO, performance, sécurité et accessibilité.",
  "sp_health_score_feat": "Analyse SEO|Vérification performance|Scan sécurité|Audit accessibilité|Rapport détaillé|Conseils d'amélioration",
  "sp_health_score_name": "Score de santé du site web",
  "sp_hosting_desc": "Infrastructure d'hébergement sécurisée, rapide et fiable pour vos sites et applications.",
  "sp_hosting_feat": "99,9% disponibilité|Certificats SSL|Sauvegardes quotidiennes|Intégration CDN|Surveillance 24/7|Auto-scaling",
  "sp_hosting_name": "Hébergement web géré",
  "sp_legal_docs_desc": "Modèles juridiques professionnels incluant NDA, contrats et CGU.",
  "sp_legal_docs_feat": "Modèles NDA|Contrats de service|CGU|Politiques de confidentialité|Conformité RGPD|Clauses personnalisées",
  "sp_legal_docs_name": "Générateur de documents juridiques",
  "sp_resume_desc": "Créez des CV optimisés ATS adaptés à votre rôle cible et votre secteur.",
  "sp_resume_feat": "Optimisation ATS|Modèles sectoriels|Correspondance mots-clés|Lettre de motivation|Optimisation LinkedIn|Export PDF",
  "sp_resume_name": "Créateur de CV intelligent",
  "sp_seo_report_desc": "Analyse automatisée du site avec recommandations SEO exploitables et insights performance.",
  "sp_seo_report_feat": "100+ points de contrôle|Métriques performance|Recommandations SEO|Analyse mobile|Revue sécurité|Plan d'action",
  "sp_seo_report_name": "Rapport d'audit du site web",
  "sp_social_cal_desc": "30 jours de contenu social généré intelligemment avec stratégie d'engagement.",
  "sp_social_cal_feat": "Calendrier 30 jours|Textes de posts|Stratégie hashtags|Conseils engagement|Meilleurs horaires|Optimisation plateforme",
  "sp_social_cal_name": "Calendrier réseaux sociaux",
  "sp_translation_desc": "Traduction professionnelle de documents en 50+ langues avec adaptation culturelle.",
  "sp_translation_feat": "50+ langues|Adaptation culturelle|Termes techniques|Livraison rapide|Relecture|Préservation du format",
  "sp_translation_name": "Traduction intelligente",
  "sp_video_script_desc": "Scripts vidéo engageants pour YouTube, TikTok et publicités optimisés pour l'engagement.",
  "sp_video_script_feat": "Scripts YouTube|Contenu TikTok|Textes publicitaires|Optimisation accroche|Placement CTA|Conseils engagement",
  "sp_video_script_name": "Rédacteur de scripts vidéo intelligent",
  "status_blocked": "Bloqué",
  "status_completed": "Terminé",
  "status_in_progress": "En cours",
  "status_planned": "Planifié",
  "admin_ratings": "Notes et retours",
  "analytics_subscription": "Abonnement",
  "developer_title": "API Développeur",
  "developer_subtitle": "Intégrez nos services intelligents dans vos applications",
  "hosting_title": "Packs d'hébergement",
  "hosting_subtitle": "Hébergement fiable et rapide pour votre entreprise",
  "privacy_s1_title": "1. Informations que nous collectons",
  "privacy_s2_title": "2. Comment nous utilisons vos informations",
  "privacy_s3_title": "3. Partage des données",
  "privacy_s4_title": "4. Sécurité des données",
  "privacy_s5_title": "5. Vos droits",
  "privacy_s6_title": "6. Cookies et suivi",
  "privacy_s7_title": "7. Conservation des données",
  "privacy_s8_title": "8. Transferts internationaux",
  "privacy_s9_title": "9. Modifications de cette politique",
  "privacy_s10_title": "10. Contactez-nous",
  "terms_s1_title": "1. Introduction",
  "terms_s2_title": "2. Services",
  "terms_s3_title": "3. Comptes utilisateurs",
  "terms_s4_title": "4. Paiements et facturation",
  "terms_s5_title": "5. Avertissement sur les services intelligents",
  "terms_s6_title": "6. Propriété intellectuelle",
  "terms_s7_title": "7. Confidentialité et données",
  "terms_s8_title": "8. Avertissement sur les cryptomonnaies",
  "terms_s9_title": "9. Limitation de responsabilité",
  "terms_s10_title": "10. Modifications",
  "terms_s11_title": "11. Droit applicable",
  "terms_s12_title": "12. Contact",
  "profile_admin_dashboard": "Ouvrir le tableau de bord admin",
  "review_title": "Ce que disent nos clients",
  "review_subtitle": "Retours réels d'entreprises que nous avons aidées",
  "marketplace_close_preview": "Fermer l'aperçu",
  "marketplace_live_preview": "Aperçu en direct",
  "testimonial_1_role": "PDG, TechStart d.o.o.",
  "testimonial_2_role": "Directrice Marketing, BioFresh",
  "testimonial_3_role": "Développeur Freelance",
  "referral_subtitle": "Invitez vos amis et gagnez des récompenses",
  "try_free_title": "Outils gratuits et services d'essai",
  "try_free_subtitle": "Sans carte de crédit. Commencez à utiliser nos outils maintenant.",
  "try_free_section": "Entièrement gratuit — aucun compte requis",
  "try_free_trial_section": "Services intelligents — Essayez avec des crédits",
  "try_free_trial_desc": "Inscrivez-vous pour obtenir des crédits et accéder aux services intelligents.",
  "try_free_cta": "Prêt à commencer ?",
  "try_free_cta_desc": "Créez un compte gratuit pour vos premiers crédits et débloquez tous les services.",
  "try_free_cta_btn": "Inscription gratuite",
  "support_tickets": "Tickets de support",
  "admin_support_tickets": "Tickets de support",
  "admin_auto_translate": "Traduction auto",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "Prospection IA",
  "admin_project_mgmt": "Gestion de projet",
  "admin_analytics_widget": "Widget analytique",
  "admin_doc_mgmt": "Gestion de documents",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "Marque blanche",
  "admin_multi_tenant": "Multi-locataire",
  "popular_services": "Services populaires",
  "popular_services_desc": "Les plus demandés par nos clients",
  "purchases": "Achats",
  "admin_funnel": "Entonnoir de conversion",
  "admin_wl_licensing": "Licences SaaS",
  "admin_analytics_export": "Export analytique",
  "service_detail_features": "Ce qui est inclus",
  "service_detail_related": "Services connexes",
  "service_detail_back": "Tous les services",
  "checkout_currency": "Devise de paiement",
  "upsell_title": "Complétez votre configuration",
  "upsell_desc": "Les clients ayant acheté similaire ont aussi ajouté:",
  "cart_checkout": "Paiement",
  "cart_empty": "Votre panier est vide",
  "push_notifications": "Notifications push",
  "push_enabled": "Notifications activées",
  "push_disabled": "Activer les notifications",
  "blog_ai_generate": "Génération IA",
  "blog_gen_service": "Générer pour service",
  "blog_generating": "Génération...",
  "export_revenue": "Rapport de revenus",
  "export_funnel": "Entonnoir de conversion",
  "export_users": "Liste des utilisateurs",
  "export_pdf": "Résumé exécutif",
  "license_generate": "Générer licence",
  "license_revoke": "Révoquer",
  "license_renew": "Renouveler",
  "license_validate": "Valider",
  "tier_starter": "Starter",
  "tier_professional": "Professionnel",
  "tier_enterprise": "Entreprise",
  "blog_subtitle": "Conseils, mises à jour et guides d'Infinity Business.",
  "blog_search_placeholder": "Rechercher des articles...",
  "blog_all": "Tous",
  "blog_no_posts": "Aucun article trouvé. Revenez bientôt !",
  "blog_prev": "Précédent",
  "blog_next": "Suivant",
  "blog_back": "Retour au blog",
  "micro_tools": "Micro-outils intelligents",
  "micro_tools_title": "Micro-outils intelligents",
  "micro_tools_subtitle": "Micro-outils gratuits alimentés par l'IA",
  "color_palette_title": "Générateur de palette de couleurs",
  "color_palette_desc": "Générez de belles palettes pour votre marque",
  "color_palette_generate": "Générer une palette",
  "color_palette_copy": "Copier",
  "color_palette_copied": "Copié !",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Complémentaire",
  "color_palette_analogous": "Analogue",
  "color_palette_triadic": "Triadique",
  "color_palette_monochromatic": "Monochromatique",
  "admin_menu_overview": "Aperçu",
  "admin_menu_users": "Utilisateurs",
  "admin_menu_blog": "Gestionnaire de blog",
  "admin_menu_analytics": "Analytique",
  "admin_menu_settings": "Paramètres",
  "admin_menu_services": "Services",
  "admin_menu_chat": "Sessions de chat",
  "admin_menu_notifications": "Notifications",
  "admin_menu_support": "Support",
  "admin_menu_security": "Sécurité",
  "admin_menu_backup": "Sauvegarde",
  "admin_menu_revenue": "Revenus",
  "admin_menu_funnel": "Entonnoir",
  "admin_menu_invoicing": "Facturation",
  "admin_menu_projects": "Projets",
  "admin_menu_email": "Éditeur d'e-mails",
  "admin_menu_ai_config": "Config. IA",
  "admin_menu_live_analytics": "Analytique en direct",
  "admin_menu_platform_audit": "Audit de plateforme",
  "docs_title": "Documentation",
  "docs_subtitle": "Apprenez à utiliser notre plateforme",
  "try_free_title": "Essai gratuit",
  "try_free_subtitle": "Découvrez nos services gratuitement",
  "subscription_title": "Plans d'abonnement",
  "subscription_subtitle": "Choisissez le plan qui vous convient",
  "portfolio_title": "Portfolio",
  "portfolio_subtitle": "Notre travail parle de lui-même",
  "svc_web-dev_label": "Développement Web",
  "svc_web-dev_desc": "Sites web, pages de destination et applications web",
  "svc_mobile-app_label": "Développement d'Apps Mobiles",
  "svc_mobile-app_desc": "Apps iOS & Android, solutions multiplateforme",
  "svc_graphic-design_label": "Design Graphique",
  "svc_graphic-design_desc": "Logos, branding, supports marketing",
  "svc_custom-software_label": "Logiciel Sur Mesure",
  "svc_custom-software_desc": "Automatisation d'entreprise personnalisée",
  "svc_ai-business-plan_label": "Générateur de Business Plan",
  "svc_ai-business-plan_desc": "Plan complet avec finances et analyse de marché",
  "svc_ai-seo-report_label": "Audit Web et Rapport SEO",
  "svc_ai-seo-report_desc": "Analyse automatisée avec recommandations",
  "svc_ai-email-campaign_label": "Configuration Email Marketing",
  "svc_ai-email-campaign_desc": "L'IA rédige le contenu et configure les séquences",
  "svc_ai-competitor-analysis_label": "Rapport d'Analyse Concurrentielle",
  "svc_ai-competitor-analysis_desc": "Intelligence de marché et positionnement",
  "svc_ai-legal-docs_label": "Générateur de Documents Juridiques",
  "svc_ai-legal-docs_desc": "NDA, contrats, modèles de CGV",
  "svc_crypto-education_label": "Éducation Crypto",
  "svc_crypto-education_desc": "Apprenez la blockchain, DeFi et les fondamentaux crypto",
  "svc_investment-tools_label": "Outils d'Investissement",
  "svc_investment-tools_desc": "Suivi de portefeuille et analyse de marché",
  "svc_defi-solutions_label": "Solutions DeFi",
  "svc_defi-solutions_desc": "Contrats intelligents, yield farming",
  "svc_personal-advertising_label": "Marque Personnelle",
  "svc_personal-advertising_desc": "Construisez votre présence en ligne",
  "svc_ai-resume_label": "Constructeur de CV Intelligent",
  "svc_ai-resume_desc": "CVs optimisés ATS",
  "svc_ai-brand-kit_label": "Logo et Kit de Marque Intelligent",
  "svc_ai-brand-kit_desc": "Logo, palette de couleurs, typographie et assets",
  "svc_ai-social-calendar_label": "Calendrier Réseaux Sociaux",
  "svc_ai-social-calendar_desc": "30 jours de posts générés par IA",
  "svc_ai-translation_label": "Service de Traduction Intelligent",
  "svc_ai-translation_desc": "Traduction professionnelle en 50+ langues",
  "svc_ai-video-script_label": "Scripteur Vidéo Intelligent",
  "svc_ai-video-script_desc": "Scripts YouTube, TikTok et publicités",
  "admin_grp_dashboard": "Tableau de bord",
  "admin_grp_users": "Utilisateurs et accès",
  "admin_grp_analytics": "Analyse et rapports",
  "admin_grp_services": "Services et tarifs",
  "admin_grp_crypto": "Crypto et DeFi",
  "admin_grp_leads": "Prospects et CRM",
  "admin_grp_content": "Contenu",
  "admin_grp_comm": "Communication",
  "admin_grp_social": "Réseaux sociaux",
  "admin_grp_ai": "IA et automatisation",
  "admin_grp_design": "Design et image de marque",
  "admin_grp_system": "Système",
  "admin_grp_projects": "Projets et QA",
  "color_palette_professional": "Professionnel",
  "color_palette_playful": "Ludique",
  "color_palette_luxury": "Luxe",
  "color_palette_nature": "Nature",
  "color_palette_tech": "Tech",
  "color_palette_warm": "Chaud",
  "color_palette_cool": "Froid",
  "blog_translating": "Traduction en cours...",
  "blog_translated_cached": "Traduit",
  "blog_translated_fresh": "Vient d'être traduit",
  "blog_show_original": "Voir l'original",
  "privacy_s1_content": "Nous collectons les informations que vous nous fournissez directement, notamment :\n- **Informations de compte** : Nom, adresse e-mail et mot de passe.\n- **Demandes de service** : Détails du projet, budget et coordonnées.\n- **Informations de paiement** : Données de facturation traitées par nos partenaires (Stripe, myPOS).\n- **Données de communication** : Messages via RisTA, formulaires de contact et correspondance.\n- **Données d'utilisation** : Type de navigateur, adresse IP, pages visitées.",
  "privacy_s2_content": "Nous utilisons les informations collectées pour :\n- Fournir, maintenir et améliorer nos services\n- Traiter les transactions et envoyer les informations associées\n- Envoyer des avis techniques, mises à jour et messages de support\n- Répondre à vos commentaires, questions et demandes\n- Surveiller et analyser les tendances et activités\n- Détecter et prévenir les fraudes\n- Personnaliser votre expérience avec RisTA",
  "privacy_s3_content": "Nous ne vendons pas vos données personnelles. Nous pouvons partager des informations avec :\n- **Prestataires de services** : Entreprises qui fournissent des services en notre nom.\n- **Exigences légales** : Lorsque la loi l'exige.\n- **Transferts commerciaux** : En lien avec des fusions ou ventes.\n- **Consentement** : Avec votre consentement explicite.",
  "privacy_s4_content": "Nous mettons en œuvre des mesures de sécurité standard :\n- Chiffrement des données en transit (TLS/SSL) et au repos\n- Support de l'authentification à deux facteurs (2FA)\n- Audits de sécurité réguliers\n- Contrôles d'accès et authentification\n- Traitement sécurisé des paiements",
  "privacy_s5_content": "En vertu des lois applicables (RGPD), vous avez le droit de :\n- **Accès** : Demander une copie de vos données personnelles\n- **Rectification** : Demander la correction de données inexactes\n- **Effacement** : Demander la suppression de vos données\n- **Limitation** : Demander la limitation du traitement\n- **Portabilité** : Demander le transfert dans un format lisible\n- **Opposition** : S'opposer au traitement\n- **Retrait du consentement** : Retirer le consentement à tout moment\n\nContactez-nous à privacy@infinitybusiness.org.",
  "privacy_s6_content": "Nous utilisons des cookies essentiels pour votre session et vos préférences. Vous pouvez gérer les cookies via votre navigateur.",
  "privacy_s7_content": "Nous conservons vos données uniquement le temps nécessaire pour les finalités pour lesquelles elles ont été collectées.",
  "privacy_s8_content": "Vos données peuvent être transférées hors de l'EEE. Nous assurons des garanties appropriées.",
  "privacy_s9_content": "Nous pouvons mettre à jour cette politique de confidentialité périodiquement. Les changements importants seront publiés sur cette page.",
  "privacy_s10_content": "Pour toute question, contactez :\n\n**Liber Nostra d.o.o.**\nEmail : privacy@infinitybusiness.org\nSite : infinitybusiness.org",
  "terms_s1_content": "Bienvenue sur Infinity Business (\"infinitybusiness.org\"), exploité par **Liber Nostra d.o.o.**. En accédant à notre plateforme, vous acceptez ces Conditions.",
  "terms_s2_content": "Infinity Business fournit des services numériques assistés par IA :\n- Développement web, apps mobiles et design graphique (B2B)\n- Services entreprise et publicité numérique\n- Éducation crypto, outils d'investissement et DeFi (P2P)\n- Assistant IA RisTA\n- Domaines et hébergement web",
  "terms_s3_content": "Pour certaines fonctionnalités, vous devez créer un compte. Vous êtes responsable de la confidentialité de vos identifiants.",
  "terms_s4_content": "Les services peuvent nécessiter un paiement. Paiements traités par des tiers (Stripe, PayPal, crypto). Politiques de remboursement :\n- **Services uniques** : Non remboursables.\n- **Abonnements** : Annulables à tout moment.\n- **Projets personnalisés** : Selon accord individuel.",
  "terms_s5_content": "Notre assistant IA \"RisTA\" fournit des conseils automatisés. À titre informatif uniquement.",
  "terms_s6_content": "Tout le contenu de cette plateforme est la propriété de Liber Nostra d.o.o.",
  "terms_s7_content": "Votre utilisation est également régie par notre Politique de Confidentialité.",
  "terms_s8_content": "Les services liés aux cryptomonnaies sont à titre informatif. Nous ne fournissons pas de conseils financiers.",
  "terms_s9_content": "Liber Nostra d.o.o. ne sera pas responsable des dommages indirects ou consécutifs.",
  "terms_s10_content": "Nous nous réservons le droit de modifier ces Conditions à tout moment.",
  "terms_s11_content": "Ces Conditions sont régies par les lois de la République de Slovénie.",
  "terms_s12_content": "Pour toute question, contactez-nous ou écrivez à support@infinitybusiness.org.",
  "admin_ad_generator": "Générateur de publicités",
  "admin_add": "Ajouter",
  "admin_add_prompt": "Ajouter un prompt",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Rapports avancés",
  "admin_all": "Tous",
  "admin_analytics_dashboard": "Tableau de bord Analytics",
  "admin_api_key": "API Key",
  "admin_apply": "Appliquer",
  "admin_approved": "Approuvé",
  "admin_archive": "Archiver",
  "admin_are_you_sure": "Êtes-vous sûr ?",
  "admin_audit_alerts": "Alertes d'audit",
  "admin_author": "Auteur",
  "admin_avg_session": "Session moyenne",
  "admin_back": "Retour",
  "admin_badge": "Badge",
  "admin_balance": "Solde",
  "admin_banned": "Banni",
  "admin_blog_manager": "Gestionnaire de blog",
  "admin_body": "Body",
  "admin_bounce_rate": "Taux de rebond",
  "admin_browser": "Navigateur",
  "admin_campaign": "Campagne",
  "admin_cannot_undo": "Cette action est irréversible",
  "admin_category": "Catégorie",
  "admin_click_rate": "Taux de clic",
  "admin_close": "Fermer",
  "admin_completed": "Terminé",
  "admin_configuration": "Configuration",
  "admin_confirm": "Confirmer",
  "admin_contact_info": "Infos de contact",
  "admin_content": "Contenu",
  "admin_conversations": "Conversations",
  "admin_conversion_funnel": "Entonnoir de conversion",
  "admin_conversion_rate": "Taux de conversion",
  "admin_copied": "Copié dans le presse-papiers",
  "admin_copy": "Copier",
  "admin_count": "Nombre",
  "admin_country": "Pays",
  "admin_create": "Créer",
  "admin_create_experiment": "Créer une expérience",
  "admin_create_new": "Créer un nouveau",
  "admin_created_success": "Créé avec succès",
  "admin_credit_config": "Configuration des crédits",
  "admin_critical": "Critique",
  "admin_custom": "Personnalisé",
  "admin_daily": "Quotidien",
  "admin_date": "Date",
  "admin_delete_failed": "Échec de la suppression",
  "admin_deleted_success": "Supprimé avec succès",
  "admin_demo_access": "Accès démo",
  "admin_description": "Description",
  "admin_deselect_all": "Tout désélectionner",
  "admin_details": "Détails",
  "admin_device": "Appareil",
  "admin_disable": "Désactiver",
  "admin_disabled": "Désactivé",
  "admin_doc_viewer": "Visionneuse de documents",
  "admin_documentation": "Documentation",
  "admin_download": "Télécharger",
  "admin_draft": "Brouillon",
  "admin_duplicate": "Dupliquer",
  "admin_email": "Email",
  "admin_enable": "Activer",
  "admin_enabled": "Activé",
  "admin_end_date": "Date de fin",
  "admin_endpoint": "Endpoint",
  "admin_error": "Erreur",
  "admin_escalation_queue": "File d'attente d'escalade",
  "admin_event": "Événement",
  "admin_events": "Événements",
  "admin_experiment_name": "Nom de l'expérience",
  "admin_export": "Exporter",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "Faux",
  "admin_filter": "Filtrer",
  "admin_frequency": "Fréquence",
  "admin_generate": "Générer",
  "admin_headers": "Headers",
  "admin_health_monitoring": "Suivi de l'état",
  "admin_high": "Haute",
  "admin_high_value_leads": "Leads à haute valeur",
  "admin_id": "ID",
  "admin_image": "Image",
  "admin_import": "Importer",
  "admin_in_progress": "En cours",
  "admin_inactive": "Inactif",
  "admin_inbox": "Boîte de réception Admin",
  "admin_speed_audit": "Audit de Vitesse",
  "admin_info": "Info",
  "admin_ip_address": "Adresse IP",
  "admin_joined": "Inscrit",
  "admin_knowledge_base": "Base de connaissances",
  "admin_language": "Langue",
  "admin_last_activity": "Dernière activité",
  "admin_last_login": "Dernière connexion",
  "admin_last_triggered": "Dernier déclenchement",
  "admin_lead_score": "Lead Score",
  "admin_level": "Niveau",
  "admin_load_failed": "Échec du chargement",
  "admin_loading_data": "Chargement des données...",
  "admin_low": "Basse",
  "admin_medium": "Moyenne",
  "admin_messages": "Messages",
  "admin_method": "Method",
  "admin_monetization": "Monétisation",
  "admin_monthly": "Mensuel",
  "admin_name": "Nom",
  "admin_next": "Suivant",
  "admin_no": "Non",
  "admin_no_data_available": "Aucune donnée disponible",
  "admin_no_experiments": "Aucune expérience trouvée",
  "admin_no_leads": "Aucun lead trouvé",
  "admin_no_prompts": "Aucun prompt trouvé",
  "admin_no_results": "Aucun résultat",
  "admin_no_results_found": "Aucun résultat trouvé",
  "admin_none": "Aucun",
  "admin_off": "Off",
  "admin_on": "On",
  "admin_open_rate": "Taux d'ouverture",
  "admin_page_views": "Pages vues",
  "admin_partner_badges": "Badges partenaires",
  "admin_payload": "Payload",
  "admin_payment_options": "Options de paiement",
  "admin_platform": "Plateforme",
  "admin_platform_audit": "Audit de la plateforme",
  "admin_points": "Points",
  "admin_portfolio_manager": "Gestionnaire de portefeuille",
  "admin_preloader_config": "Configuration du Preloader",
  "admin_preview": "Aperçu",
  "admin_previous": "Précédent",
  "admin_price": "Prix",
  "admin_priority": "Priorité",
  "admin_prompt_name": "Nom du prompt",
  "admin_prompt_text": "Texte du prompt",
  "admin_published": "Publié",
  "admin_recipients": "Destinataires",
  "admin_referral": "Referral",
  "admin_referral_leaderboard": "Classement de parrainage",
  "admin_refresh": "Actualiser",
  "admin_rejected": "Rejeté",
  "admin_remove": "Supprimer",
  "admin_reset": "Réinitialiser",
  "admin_response_time": "Temps de réponse",
  "admin_restore": "Restaurer",
  "admin_results": "Résultats",
  "admin_retry": "Réessayer",
  "admin_revenue_dashboard": "Tableau de bord des revenus",
  "admin_rista_services": "Services RisTA",
  "admin_role": "Rôle",
  "admin_save_changes": "Enregistrer les modifications",
  "admin_save_failed": "Échec de l'enregistrement",
  "admin_saved_success": "Enregistré avec succès",
  "admin_scheduled": "Planifié",
  "admin_search": "Rechercher",
  "admin_select": "Sélectionner",
  "admin_select_all": "Tout sélectionner",
  "admin_send": "Envoyer",
  "admin_sent_success": "Envoyé avec succès",
  "admin_server_resources": "Ressources serveur",
  "admin_service_manager": "Gestionnaire de services",
  "admin_session_duration": "Durée de session",
  "admin_settings": "Paramètres",
  "admin_slug": "Slug",
  "admin_social_automation": "Automatisation sociale",
  "admin_something_wrong": "Une erreur est survenue",
  "admin_source": "Source",
  "admin_start_date": "Date de début",
  "admin_subject": "Sujet",
  "admin_submit": "Soumettre",
  "admin_subscribers": "Abonnés",
  "admin_success": "Succès",
  "admin_suspended": "Suspendu",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Tags",
  "admin_template": "Template",
  "admin_templates": "Templates",
  "admin_test_results": "Résultats de test",
  "admin_tester_program": "Programme de testeurs",
  "admin_title": "Titre",
  "admin_total_revenue": "Revenu total",
  "admin_total_sessions": "Total sessions",
  "admin_total_users": "Total utilisateurs",
  "admin_trigger": "Déclencheur",
  "admin_true": "Vrai",
  "admin_try_again": "Veuillez réessayer",
  "admin_type": "Type",
  "admin_unique_visitors": "Visiteurs uniques",
  "admin_unsubscribed": "Désabonnés",
  "admin_unverified": "Non vérifié",
  "admin_update": "Mettre à jour",
  "admin_updated_success": "Mis à jour avec succès",
  "admin_upload": "Téléverser",
  "admin_urgent": "Urgent",
  "admin_user": "Utilisateur",
  "admin_variant_a": "Variant A",
  "admin_variant_b": "Variant B",
  "admin_verified": "Vérifié",
  "admin_version": "Version",
  "admin_view": "Voir",
  "admin_view_details": "Voir les détails",
  "admin_viewer": "Lecteur",
  "admin_warning": "Avertissement",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Hebdomadaire",
  "admin_yes": "Oui",
  "admin_analytics_digestadmin_analytics_digest": "Resume analytique",
  "admin_blog_health": "Sante du blog",
  "credit_title": "Crédits",
  "credit_subtitle": "Solde prépayé pour les services intelligents",
  "credit_available_balance": "Solde disponible",
  "credit_tab_balance": "Solde",
  "credit_tab_topup": "Recharger",
  "credit_tab_history": "Historique",
  "credit_tab_services": "Services",
  "credit_tab_crypto": "Crypto",
  "credit_balance_desc": "Votre crédit peut être utilisé pour tout service IA :",
  "credit_bulk_discounts": "Remises en volume",
  "credit_add_credits": "Ajouter des crédits",
  "credit_select_amount": "Sélectionnez un montant ou saisissez une valeur :",
  "credit_bonus": "bonus",
  "credit_bonus_detail": "Vous obtiendrez",
  "credit_total_word": "total",
  "credit_method_card": "Carte",
  "credit_method_crypto": "Crypto",
  "credit_processing": "Traitement...",
  "credit_add_btn": "Ajouter",
  "credit_no_txn": "Aucune transaction",
  "credit_txn_topup": "Recharge",
  "credit_txn_promo": "Crédit promo",
  "credit_txn_auto": "Achat auto",
  "credit_txn_purchase": "Achat",
  "credit_svc_intelligent": "Service intelligent",
  "credit_svc_available": "Disponible",
  "credit_svc_need_more": "Besoin de",
  "credit_svc_more": "plus",
  "credit_crypto_send": "Envoyer",
  "credit_crypto_amount": "Montant :",
  "credit_crypto_equivalent": "équivalent",
  "credit_crypto_network": "Réseau :",
  "credit_crypto_wallet": "Adresse du portefeuille",
  "credit_crypto_confirm": "Les crédits seront ajoutés après confirmation de la transaction.",
  "credit_payment_id": "ID de paiement :",
  "credit_crypto_back": "Retour à la sélection crypto",
  "credit_crypto_select_title": "Sélectionner une crypto-monnaie pour la recharge",
  "credit_crypto_choose_desc": "Choisissez une pièce. Vous recevrez une adresse de portefeuille.",
  "credit_crypto_select_btn": "Sélectionner",
  "credit_minimum": "Minimum €5",
  "credit_redirecting": "Redirection...",
  "credit_topup_failed": "Échec de la recharge",
  "credit_crypto_failed": "Échec du paiement crypto",
  "cart_title": "Panier",
  "cart_total": "Total",
  "cart_stripe_checkout": "Paiement Stripe",
  "cart_credits": "Crédits",
  "cart_secure_stripe": "Paiement Stripe sécurisé",
  "cart_insufficient": "Crédits insuffisants. Rechargez d'abord ou choisissez le paiement par carte.",
  "cart_pay_card": "Payer par carte",
  "cart_pay_credits_btn": "Payer avec des crédits",
  "cart_clear": "Vider le panier",
  "cart_processing": "Traitement...",
  "cart_payment_success": "Paiement réussi ! Votre commande est en cours de traitement.",
  "cart_complete_setup": "Complétez votre configuration",
  "cart_also_added": "Les clients ayant acheté des services similaires ont aussi ajouté :",
  "cart_add": "Ajouter",
  "cart_standard": "Standard",
  "cart_remaining_balance": "Solde restant :",
  "cart_checkout_failed": "Échec du paiement",
  "cart_checkout_no_session": "Impossible de créer la session de paiement",
  "cart_purchased": "Acheté",
  "cart_services_with_credits": "service(s) avec des crédits !",
  "credits_balance_title": "Solde de crédits",
  "credits_topup_btn": "Recharger les crédits",
  "credits_rate": "1 EUR = 1 Crédit",
  "credits_total_topup": "Total rechargé",
  "credits_spent_credits": "Dépensé (Crédits)",
  "credits_spent_payments": "Dépensé (Paiements)",
  "credits_txn_history": "Historique des transactions",
  "credits_no_txn": "Aucune transaction",
  "credits_txn_topup": "Recharge",
  "credits_txn_promo": "Crédit promo",
  "credits_txn_purchase": "Achat de service",
  "credits_txn_ai": "Service IA",
  "credits_order_history": "Historique des commandes",
  "credits_order_label": "Commande :",
  "chat_translate_btn": "Traduire en anglais",
  "chat_translating": "Traduction...",
  "chat_translated_label": "Traduction anglaise affichée. Cliquez sur « Afficher l'original » pour les messages originaux.",
  "chat_show_original": "Afficher l'original",
  "chat_show_translated": "Afficher la traduction",
  "pkg_section_badge": "Offres Limitées",
  "pkg_section_title": "Lancez Votre Entreprise",
  "pkg_section_title_highlight": "Aujourd'hui",
  "pkg_section_subtitle": "Des packages Premium conçus pour vous mettre en ligne rapidement — avec une technologie intelligente intégrée dès le premier jour.",
  "pkg_section_footer": "Tous les prix excluent la TVA le cas échéant. Pas sûr de quel package convient ? Discutez avec RisTA pour une consultation gratuite.",
  "pkg_cta_default": "Commencer",
  "admin_package_mgr": "Gestionnaire de Paquet",
  "admin_pkg_title": "Packages de Page d'Atterrissage",
  "admin_pkg_subtitle": "Gérez les packages de prix mis en avant affichés sur la page d'atterrissage",
  "admin_pkg_seed": "Valeurs par Défaut",
  "admin_pkg_new": "Nouveau Package",
  "admin_pkg_create_title": "Créer un Nouveau Package",
  "admin_pkg_edit_title": "Modifier le Package",
  "admin_pkg_name": "Nom du Package",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Description",
  "admin_pkg_price": "Prix",
  "admin_pkg_currency": "Devise",
  "admin_pkg_price_note": "Note de Prix",
  "admin_pkg_badge": "Badge",
  "admin_pkg_accent": "Couleur d'Accent",
  "admin_pkg_cta_text": "Texte du Bouton CTA",
  "admin_pkg_cta_link": "Lien CTA (optionnel)",
  "admin_pkg_sort": "Ordre de Tri",
  "admin_pkg_features": "Fonctionnalités / Services Inclus",
  "admin_pkg_add_feature": "Ajouter une Fonctionnalité",
  "admin_pkg_highlighted": "Mis en Avant",
  "admin_pkg_normal": "Normal",
  "admin_pkg_create": "Créer un Package",
  "admin_pkg_save": "Sauvegarder les Modifications",
  "admin_pkg_saving": "Sauvegarde en cours...",
  "admin_pkg_cancel": "Annuler",
  "admin_pkg_empty_title": "Aucun package configuré pour l'instant",
  "admin_pkg_empty_desc": "Cliquez sur Valeurs par Défaut pour générer deux packages de démarrage, ou créez le vôtre.",
  "admin_pkg_features_label": "fonctionnalités",
  "admin_pkg_sort_label": "Trier",
  "admin_pkg_delete_confirm": "Supprimer ce package ? Il sera retiré de la page d'atterrissage.",
  "admin_pkg_feature_placeholder": "Description de la fonctionnalité...",
  "admin_pkg_pricenote_placeholder": "par ex. Unique / +5% part de revenus",
  "admin_pkg_badge_placeholder": "par ex. MEILLEURE VALEUR",
  "admin_pkg_loading": "Chargement des forfaits...",
  "pkg_qa_have_domain": "Oui, j'ai un domaine",
  "pkg_qa_need_domain": "J'ai besoin d'un domaine",
  "pkg_qa_describe_biz": "Laissez-moi décrire mon entreprise",
  "pkg_qa_more_info": "Dites-moi en plus sur ce forfait",
  "sp_managed_hosting": "Hébergement Géré",
  "sp_managed_hosting_desc": "Hébergement entièrement géré avec surveillance et support.",
  "sp_enterprise_ad": "Publicité Entreprise",
  "sp_enterprise_ad_desc": "Campagnes publicitaires à grande échelle avec stratégie dédiée.",
  "sp_email_marketing": "Configuration Email Marketing",
  "sp_email_marketing_desc": "Séquences email professionnelles et automatisation.",
  "sp_competitor_analysis": "Rapport d'Analyse Concurrentielle",
  "sp_competitor_analysis_desc": "Intelligence de marché et positionnement concurrentiel.",
  "sp_website_audit": "Audit Web & Rapport SEO",
  "sp_website_audit_desc": "Analyse complète du site avec recommandations actionnables.",
  "sp_managed_trading": "Trading Géré",
  "sp_managed_trading_desc": "Trading géré par des experts avec des stratégies éprouvées.",
  "sp_trading_consult": "Consultations Trading",
  "sp_trading_consult_desc": "Sessions individuelles de stratégie de trading.",
  "sp_domains": "LiveDomain Aftermarket",
  "sp_domains_desc": "Acquisition premium de domaines et offres aftermarket.",
  "sp_domain_mgmt": "Gestion de Domaines",
  "sp_domain_mgmt_desc": "Gestion DNS, renouvellements et transferts.",
  "sp_defi": "Solutions DeFi",
  "sp_defi_desc": "Contrats intelligents, yield farming et pools de liquidité.",
  "sp_personal_brand": "Personal Branding",
  "sp_personal_brand_desc": "Construisez votre présence en ligne et votre marque personnelle.",
  "sp_ad_gen": "Générateur d'Annonces",
  "sp_ad_gen_desc": "Générez instantanément des textes publicitaires performants.",
  "sp_priority": "File Prioritaire",
  "sp_priority_desc": "Réponse garantie sous 4 heures.",
  "sp_maintenance": "Plan de Maintenance",
  "sp_maintenance_desc": "Maintenance continue, mises à jour et support technique.",
  "sp_consulting": "Consultation Intelligente",
  "sp_consulting_desc": "Consultation individuelle avec nos experts technologiques.",
  "sp_market_snapshot": "Aperçu du Marché",
  "sp_market_snapshot_desc": "Vue rapide du paysage de votre marché et des tendances.",
  "sp_trend_explainer": "Explicateur de Tendances",
  "sp_trend_explainer_desc": "Comprenez les tendances émergentes de votre industrie.",
  "sp_competitor_qa": "Questions sur les Concurrents",
  "sp_competitor_qa_desc": "Réponses sur les stratégies de vos concurrents.",
  "sp_country_entry": "Vérification d'Entrée Pays",
  "sp_country_entry_desc": "Évaluez la maturité du marché pour l'expansion internationale.",
  "sp_vendor_shortlist": "Liste de Fournisseurs",
  "sp_vendor_shortlist_desc": "Liste curatée de fournisseurs pour vos besoins.",
  "sp_tam_logic": "Esquisse TAM",
  "sp_tam_logic_desc": "Estimation du marché total avec décomposition logique.",
  "sp_positioning": "Angle de Positionnement",
  "sp_positioning_desc": "Analyse de stratégie de positionnement produit + audience.",
  "sp_addon_title": "Add-ons & Support",
  "sp_addon_desc": "Renforcez votre projet avec un support prioritaire et des consultations expertes.",
  "sp_research_title": "Produits de Recherche Intelligente",
  "sp_research_desc": "Intelligence de marché à la demande et outils d'analyse intelligente.",
  "tier_section_badge": "Forfaits Intelligents",
  "tier_section_title": "Choisissez Votre",
  "tier_section_highlight": "Plan de Croissance",
  "tier_section_subtitle": "Forfaits groupés conçus pour une valeur maximale. Choisissez le niveau adapté.",
  "tier_one_time": "Paiement Unique",
  "tier_monthly": "Mensuel",
  "tier_section_footer": "Tous les prix sont hors TVA. Besoin d'un forfait personnalisé ? Discutez avec RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Parfait pour débuter votre présence numérique",
  "tier_tag_growth": "Développez votre entreprise avec des outils intelligents",
  "tier_tag_pro": "Croissance numérique complète pour les entreprises sérieuses",
  "tier_tag_enterprise": "Transformation numérique complète pour votre entreprise",
  "tier_cta_starter": "Choisir Starter",
  "tier_cta_growth": "Choisir Growth",
  "tier_cta_pro": "Choisir Pro",
  "tier_cta_enterprise": "Choisir Enterprise",
  "tier_badge_popular": "POPULAIRE",
  "tier_badge_best": "MEILLEURE VALEUR",
  "tier_badge_all": "TOUT-EN-UN",
  "tier_per_mo": "mois",
  "tier_once_label": "paiement unique",
  "tier_or_monthly": "ou",
  "tier_f_starter_1": "Générateur intelligent de business plan",
  "tier_f_starter_2": "Constructeur intelligent de CV (3 pièces)",
  "tier_f_starter_3": "Audit web et rapport SEO",
  "tier_f_starter_4": "Logo et kit de marque intelligent",
  "tier_f_starter_5": "Rapport aperçu du marché",
  "tier_f_starter_6": "Brouillon de réponses FAQ",
  "tier_f_starter_7": "Plan de blog à partir de tendance",
  "tier_f_starter_8": "Support email sous 48h",
  "tier_f_growth_1": "Tout du Starter",
  "tier_f_growth_2": "Campagne email intelligente",
  "tier_f_growth_3": "Calendrier et analyse réseaux sociaux (3 mois)",
  "tier_f_growth_4": "Rapport d'analyse concurrentielle",
  "tier_f_growth_5": "Générateur d'annonces (5 campagnes)",
  "tier_f_growth_6": "Générateur d'emails de prospection",
  "tier_f_growth_7": "Explicateur de tendances",
  "tier_f_growth_8": "Analyse de positionnement",
  "tier_f_growth_9": "Support email prioritaire sous 24h",
  "tier_f_pro_1": "Tout du Growth",
  "tier_f_pro_2": "Configuration SEO et marketing digital",
  "tier_f_pro_3": "Configuration email marketing",
  "tier_f_pro_4": "Rédacteur intelligent de scripts vidéo (5 pièces)",
  "tier_f_pro_5": "Esquisse rapide logique TAM",
  "tier_f_pro_6": "Check-list des risques",
  "tier_f_pro_7": "Priorisation des fonctionnalités",
  "tier_f_pro_8": "Brouillon liste de fournisseurs",
  "tier_f_pro_9": "Session de consultation intelligente (2h)",
  "tier_f_pro_10": "Support prioritaire sous 12h",
  "tier_f_ent_1": "Tout du Pro",
  "tier_f_ent_2": "Développement logiciel sur mesure",
  "tier_f_ent_3": "Stratégie publicitaire entreprise",
  "tier_f_ent_4": "Hébergement géré (12 mois)",
  "tier_f_ent_5": "Plan de maintenance (6 mois)",
  "tier_f_ent_6": "Consultation intelligente (10h)",
  "tier_f_ent_7": "Vérification d'entrée pays",
  "tier_f_ent_8": "Résumé exécutif pour présentations",
  "tier_f_ent_9": "Énoncé de problème JTBD",
  "tier_f_ent_10": "Gestionnaire de compte dédié",
  "tier_f_ent_11": "File prioritaire (réponse 4h)",
  "calc_title": "Calculateur de Prix",
  "calc_subtitle": "Comparez les services individuels aux forfaits groupés pour voir vos économies.",
  "calc_badge": "Économisez Plus",
  "calc_select_services": "Sélectionner les Services",
  "calc_search_placeholder": "Rechercher des services...",
  "calc_selected": "sélectionnés",
  "calc_your_selection": "Votre Sélection",
  "calc_individual_total": "Total Individuel",
  "calc_best_tier": "Meilleur Forfait",
  "calc_you_save": "Vous Économisez",
  "calc_no_services": "Sélectionnez des services pour voir les économies",
  "calc_clear_all": "Tout effacer",
  "calc_get_tier": "Obtenir Ce Forfait",
  "calc_individual_cheaper": "Les services individuels sont déjà rentables. Ajoutez-en plus pour débloquer des économies!",
  "referred_by": "Recommande par",
  "referral_signup_reward": "Inscrivez-vous pour associer votre compte a cette recommandation.",
  "badge_coming_soon": "Bientôt disponible",
  "badge_available_soon": "Disponible bientôt",
  "badge_from_price": "à partir de",
  "badge_preparing": "Nous préparons ce service pour vous",
  "svc_managed-hosting_label": "Hébergement géré",
  "svc_managed-hosting_desc": "Hébergement entièrement géré avec surveillance et support",
  "svc_enterprise-advertising_label": "Publicité entreprise",
  "svc_enterprise-advertising_desc": "Campagnes publicitaires à grande échelle avec stratégie dédiée",
  "svc_email-marketing_label": "Configuration email marketing",
  "svc_email-marketing_desc": "Séquences email, modèles et automatisation professionnels",
  "svc_competitor-analysis_label": "Rapport d analyse concurrentielle",
  "svc_competitor-analysis_desc": "Intelligence de marché et positionnement concurrentiel",
  "svc_legal-docs_label": "Générateur de documents juridiques",
  "svc_legal-docs_desc": "NDA, contrats, modèles de conditions générales",
  "svc_website-audit_label": "Audit web et rapport SEO",
  "svc_website-audit_desc": "Analyse complète du site avec recommandations",
  "svc_trading-consultation_label": "Consultations de trading",
  "svc_trading-consultation_desc": "Sessions de stratégie de trading guidées par des experts",
  "svc_managed-trading_label": "Trading géré",
  "svc_managed-trading_desc": "Trading géré par des experts avec des stratégies éprouvées",
  "svc_domain-management_label": "Gestion de domaines",
  "svc_domain-management_desc": "Enregistrement de domaines, gestion DNS et transferts",
  "svc_personal-branding_label": "Image de marque personnelle",
  "svc_personal-branding_desc": "Construisez votre présence en ligne et votre marque personnelle",
  "admin_escalation_alert": "Escalade de chat",
  "admin_view_escalations": "Voir la file d escalade",
  "from": "À partir de",
  "vector_gen_title": "Générateur vectoriel",
  "vector_gen_title_hl": "intelligent",
  "vector_gen_badge": "Studio vectoriel intelligent",
  "vector_gen_desc": "Décrivez votre idée, téléchargez des références et obtenez un graphique vectoriel SVG prêt à l'emploi en quelques secondes.",
  "vector_gen_balance": "Votre solde",
  "vector_gen_per_gen": "crédits par génération",
  "vector_gen_prompt_label": "Décrivez votre graphique vectoriel",
  "vector_gen_prompt_ph": "ex. Un logo minimaliste de montagne avec des rayons de soleil, utilisant des couleurs sarcelle et orange...",
  "vector_gen_style": "Style",
  "vector_gen_color": "Mode couleur",
  "vector_gen_refs": "Fichiers de référence",
  "vector_gen_optional": "optionnel, max 3",
  "vector_gen_upload": "Télécharger une référence (PNG, JPG, SVG)",
  "vector_gen_generating": "Génération en cours...",
  "vector_gen_cta": "Générer un vecteur",
  "vector_gen_result": "Votre graphique vectoriel",
  "vector_gen_model_used": "Modèle",
  "vector_gen_history": "Historique de génération",
  "vector_gen_no_history": "Pas encore de générations",
  "vector_gen_login_req": "Connectez-vous pour utiliser le générateur vectoriel.",
  "vector_gen_service_title": "Besoin de vecteurs professionnels ?",
  "vector_gen_service_desc": "Commandez des graphiques vectoriels personnalisés en tant que service de design complet avec révisions et directives de marque.",
  "vector_gen_service_cta": "Voir les services de design",
  "vector_gen_product_type": "Type de produit",
  "vector_gen_size": "Taille de sortie",
  "vector_gen_error_prompt": "Veuillez décrire votre idée de graphique vectoriel.",
  "admin_vector_gen": "Générateur vectoriel",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Page d'accueil",
  "admin_landing_text": "Textes page d'accueil",
  "admin_vector_title": "Générateur vectoriel",
  "admin_vector_models": "Modèles disponibles",
  "admin_vector_pricing": "Tarifs et limites",
  "svc_vector-generator_label": "Générateur vectoriel intelligent",
  "svc_vector-generator_desc": "Générez des graphiques vectoriels SVG prêts à l'emploi à partir de descriptions textuelles",
  "sp_vector_gen_name": "Générateur vectoriel intelligent",
  "sp_vector_gen_desc": "Générez des graphiques vectoriels SVG à partir de descriptions textuelles avec une technologie intelligente.",
  "sp_vector_gen_feat": "Génération texte vers vecteur|Export SVG et PNG|Plusieurs styles|Éditeur SVG intégré|Téléchargement de références|Tarification par crédits",
  "sp_managed_hosting_name": "Hébergement géré",
  "sp_managed_hosting_feat": "Surveillance 24/7|Mises à jour auto|Gestion SSL|Sauvegardes quotidiennes|Optimisation|Support dédié",
  "sp_enterprise_ad_name": "Publicité entreprise",
  "sp_enterprise_ad_feat": "Stratégie de campagne|Multi-canal|Tests A/B|Suivi|Gestionnaire dédié|Rapports",
  "sp_email_marketing_name": "Configuration email marketing",
  "sp_email_marketing_feat": "Séquences d'emails|Design de templates|Automatisation|Gestion de listes|Analytics|Tests A/B",
  "sp_competitor_analysis_name": "Rapport d'analyse concurrentielle",
  "sp_competitor_analysis_feat": "Analyse de marché|Profil concurrents|SWOT|Comparaison prix|Recommandations|Mises à jour",
  "sp_website_audit_name": "Audit de site web et rapport SEO",
  "sp_website_audit_feat": "Audit technique|Analyse SEO|Métriques|Accessibilité|Scan sécurité|Plan d'action",
  "sp_defi_name": "Solutions DeFi",
  "sp_defi_feat": "Smart contracts|Yield farming|Pools de liquidité|Audit DeFi|Création de tokens|Solutions de staking",
  "sp_personal_brand_name": "Image de marque personnelle",
  "sp_personal_brand_feat": "Stratégie de marque|Présence réseaux sociaux|Site web personnel|Planification de contenu|Photos professionnelles|Rédaction de bio",
  "sp_ad_gen_name": "Générateur de publicités",
  "sp_ad_gen_feat": "Textes publicitaires|Formats créatifs|Multi-plateforme|Variantes A/B|Ciblage d'audience|Conseils performance",
  "sp_priority_name": "File prioritaire",
  "sp_priority_feat": "Réponse 4 heures|Canal dédié|Traitement prioritaire|Mises à jour statut|Garantie SLA|Support étendu",
  "sp_maintenance_name": "Plan de maintenance",
  "sp_maintenance_feat": "Mises à jour mensuelles|Correctifs sécurité|Surveillance performance|Corrections de bugs|Garantie disponibilité|Support prioritaire",
  "sp_consulting_name": "Session de conseil intelligent",
  "sp_consulting_feat": "Consultation expert|Session stratégique|Conseil technique|Plan de mise en œuvre|Notes de suivi|Enregistrement fourni",
  "sp_market_snapshot_name": "Aperçu du marché",
  "sp_market_snapshot_feat": "Vue d'ensemble du marché|Tendances clés|Paysage concurrentiel|Opportunités de croissance|Facteurs de risque|Résumé exécutif",
  "sp_trend_explainer_name": "Explicateur de tendances",
  "sp_trend_explainer_feat": "Analyse des tendances|Impact industriel|Évaluation des opportunités|Projection temporelle|Actions|Rapport visuel",
  "sp_competitor_qa_name": "Questions concurrents",
  "sp_competitor_qa_feat": "Analyse stratégique|Aperçu des prix|Positionnement|Comparaison|Analyse des faiblesses|Carte des opportunités",
  "sp_country_entry_name": "Vérification d'entrée de marché",
  "sp_country_entry_feat": "Préparation du marché|Aperçu réglementaire|Facteurs culturels|Analyse concurrentielle|Stratégie d'entrée|Évaluation des risques",
  "sp_vendor_shortlist_name": "Liste restreinte fournisseurs",
  "sp_vendor_shortlist_feat": "Recherche fournisseurs|Matrice comparative|Analyse des prix|Évaluation capacités|Recommandations|Coordonnées",
  "sp_tam_logic_name": "Schéma logique TAM",
  "sp_tam_logic_feat": "Estimation TAM|Ventilation SAM/SOM|Cadre logique|Sources de données|Hypothèses de croissance|Présentation visuelle",
  "sp_positioning_name": "Angle de positionnement",
  "sp_positioning_feat": "Positionnement marché|Segmentation d'audience|Proposition de valeur|Cadre de messages|Différenciation|Avantage concurrentiel",
  "sp_managed_trading_name": "Trading géré",
  "sp_managed_trading_feat": "Gestion de portefeuille|Gestion des risques|Stratégies éprouvées|Rapports réguliers|Gestionnaire dédié|Analyse de marché",
  "sp_trading_consult_name": "Consultation trading",
  "sp_trading_consult_feat": "Sessions individuelles|Développement de stratégie|Analyse de marché|Évaluation des risques|Revue de portefeuille|Guidance expert",
  "sp_domains_name": "Marché LiveDomain",
  "sp_domains_feat": "Domaines premium|Offres aftermarket|Évaluation de domaines|Support de transfert|Négociation|Gestion de portefeuille",
  "sp_domain_mgmt_name": "Gestion de domaines",
  "sp_domain_mgmt_feat": "Gestion DNS|Renouvellement auto|Support de transfert|Suivi du portefeuille|Certificats SSL|Confidentialité Whois",
  "vector_gen_model": "Modèle",
  "vector_gen_quality": "Niveau de qualité",
  "svc_smart-resume_label": "Créateur de CV intelligent",
  "svc_smart-resume_desc": "CV optimisés pour ATS par notre système intelligent",
  "svc_smart-business-plan_label": "Générateur de business plan intelligent",
  "svc_smart-business-plan_desc": "Business plan complet avec finances et analyse de marché",
  "svc_smart-seo-report_label": "Rapport SEO intelligent",
  "svc_smart-seo-report_desc": "Analyse de site automatisée avec recommandations actionnables",
  "svc_smart-brand-kit_label": "Kit logo et marque intelligent",
  "svc_smart-brand-kit_desc": "Concept de logo, palette de couleurs, typographie et assets réseaux sociaux",
  "svc_smart-email-campaign_label": "Campagne email intelligente",
  "svc_smart-email-campaign_desc": "Email marketing intelligent avec séquences optimisées",
  "svc_smart-social-calendar_label": "Calendrier et analyse des réseaux sociaux",
  "svc_smart-social-calendar_desc": "30 jours de publications générées avec stratégie d'engagement",
  "svc_ad-generator_label": "Générateur de publicités",
  "svc_ad-generator_desc": "Générez instantanément des textes publicitaires à fort taux de conversion",
  "svc_smart-translation_label": "Services de traduction intelligents",
  "svc_smart-translation_desc": "Traduction professionnelle de documents dans plus de 50 langues",
  "svc_smart-video-script_label": "Rédacteur de scripts vidéo intelligent",
  "svc_smart-video-script_desc": "Scripts YouTube, TikTok et publicitaires optimisés pour l'engagement",
  "svc_priority-queue_label": "File d'attente prioritaire",
  "svc_priority-queue_desc": "Réponse garantie dans les 4 heures",
  "svc_maintenance-plan_label": "Plan de maintenance",
  "svc_maintenance-plan_desc": "Maintenance continue, mises à jour et support technique",
  "svc_smart-consulting_label": "Session de conseil intelligent",
  "svc_smart-consulting_desc": "Consultation individuelle avec nos experts en technologie",
  "svc_market-snapshot_label": "Aperçu du marché",
  "svc_market-snapshot_desc": "Aperçu rapide de votre paysage de marché",
  "svc_trend-explainer_label": "Explicateur de tendances",
  "svc_trend-explainer_desc": "Comprenez les tendances émergentes de votre secteur",
  "svc_competitor-qa_label": "Questions concurrents",
  "svc_competitor-qa_desc": "Obtenez des réponses sur les stratégies de vos concurrents",
  "svc_country-entry-check_label": "Vérification d'entrée de marché",
  "svc_country-entry-check_desc": "Évaluez la préparation du marché pour l'expansion internationale",
  "svc_should-i-care_label": "Vérification de pertinence",
  "svc_should-i-care_desc": "Évaluez si une tendance compte pour votre entreprise",
  "svc_report-matchmaker_label": "Recherche de rapports",
  "svc_report-matchmaker_desc": "Trouvez le bon rapport de recherche",
  "svc_which-region-first_label": "Priorité régionale",
  "svc_which-region-first_desc": "Guidance basée sur les données pour l'entrée sur un marché régional",
  "svc_vendor-shortlist_label": "Liste restreinte fournisseurs",
  "svc_vendor-shortlist_desc": "Liste curatée de fournisseurs pour vos besoins",
  "svc_forecast-explanation_label": "Explication des prévisions",
  "svc_forecast-explanation_desc": "Explication claire des prévisions de marché",
  "svc_outreach-email-gen_label": "Générateur d'emails de prospection",
  "svc_outreach-email-gen_desc": "Générez des emails de prospection personnalisés à grande échelle",
  "svc_executive-summary_label": "Résumé exécutif",
  "svc_executive-summary_desc": "Résumés prêts pour les présentations",
  "svc_faq-answer-draft_label": "Brouillon de réponses FAQ",
  "svc_faq-answer-draft_desc": "Rédigez des réponses aux questions fréquentes",
  "svc_jtbd-problem_label": "Énoncé de problème JTBD",
  "svc_jtbd-problem_desc": "Analyse de problème avec le framework JTBD",
  "svc_tam-logic-sketch_label": "Schéma logique TAM",
  "svc_tam-logic-sketch_desc": "Estimation du marché total avec ventilation logique",
  "svc_risk-checklist_label": "Liste de contrôle des risques",
  "svc_risk-checklist_desc": "Liste de contrôle complète d'évaluation des risques",
  "svc_feature-prioritization_label": "Priorisation des fonctionnalités",
  "svc_feature-prioritization_desc": "Recommandations de priorisation basées sur les données",
  "svc_next-research-question_label": "Prochaine question de recherche",
  "svc_next-research-question_desc": "Découvrez la prochaine question de recherche critique",
  "svc_positioning-angle_label": "Angle de positionnement",
  "svc_positioning-angle_desc": "Analyse de positionnement produit et audience",
  "svc_blog-outline-trend_label": "Plan de blog à partir d'une tendance",
  "svc_blog-outline-trend_desc": "Transformez les tendances en plans de blog structurés",
  "admin_ai_reports": "Rapports services IA",
  "admin_project_delivery": "Livraison de projet",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "agency_rista_tooltip": "Discuter avec RisTA",
  "agency_hero_title_1": "Des sites web ultra-rapides qui ",
  "agency_hero_title_highlight": "vendent",
  "agency_hero_title_2": " pour les entreprises locales",
  "agency_hero_subtitle_1": "Obtenez un site personnalisé qui charge en millisecondes + analytiques intégrées pour",
  "agency_hero_subtitle_2": ". Pas de pages lentes, plus de prospects — lancement en semaines.",
  "agency_hero_limited": "Places limitées !",
  "agency_hero_cta_pricing": "Voir le forfait à €498",
  "agency_hero_cta_audit": "Audit gratuit",
  "agency_trust_maintenance": "maintenance ensuite",
  "agency_trust_efficient": "100% Efficace",
  "agency_trust_powered": "Propulsé par un Système Intelligent",
  "agency_speed_title": "Vitesse de chargement du site",
  "agency_speed_before": "Avant",
  "agency_speed_after": "Après",
  "agency_speed_leads": "+35% prospects",
  "agency_pain_title_1": "Les sites lents ",
  "agency_pain_title_2": "tuent les ventes",
  "agency_pain_subtitle": "Chaque seconde de chargement de votre site vous fait perdre des clients. Voici le problème — et comment nous le résolvons.",
  "agency_pain_slow_title": "Chargement lent = Prospects perdus",
  "agency_pain_slow_desc": "Votre site met plus de 5 secondes à charger. Les visiteurs partent avant de voir votre offre. Vous payez du trafic qui ne convertit jamais.",
  "agency_pain_stats_title": "47% partent si >3s",
  "agency_pain_stats_desc": "Les recherches de Google montrent que près de la moitié des visiteurs abandonnent un site mobile qui met plus de 3 secondes à charger.",
  "agency_pain_stats_source": "Source : Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "Notre technologie Speed-First",
  "agency_pain_solution_desc": "Sites personnalisés optimisés pour charger en moins d'1 seconde. Cache edge, images optimisées, code minimisé.",
  "agency_pricing_title": "Tarifs simples et transparents",
  "agency_pricing_subtitle": "Choisissez le plan adapté à votre entreprise. Tous les plans incluent notre technologie Speed-First.",
  "agency_pricing_urgency_1": "Plus que ",
  "agency_pricing_urgency_2": " places starter ce mois-ci",
  "agency_pricing_popular": "LE PLUS POPULAIRE",
  "agency_pricing_get_started": "Commencer",
  "agency_pricing_guarantee": "Garantie satisfait ou remboursé 30 jours",
  "agency_pricing_ideal": "Idéal pour :",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "unique",
  "agency_pricing_starter_ideal": "Auto-entrepreneurs",
  "agency_pricing_s_1": "Site web personnalisé ultra-rapide",
  "agency_pricing_s_2": "Domaine + hébergement pour 1 an",
  "agency_pricing_s_3": "Tableau de bord analytique basique",
  "agency_pricing_s_4": "Design responsive mobile",
  "agency_pricing_s_5": "Certificat SSL inclus",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Boutiques en croissance",
  "agency_pricing_p_1": "Tout ce qui est dans Starter",
  "agency_pricing_p_2": "E-commerce + récupération de panier",
  "agency_pricing_p_3": "Pack optimisation SEO",
  "agency_pricing_p_4": "Intégration de tests A/B",
  "agency_pricing_p_5": "Support prioritaire",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Entreprises en expansion",
  "agency_pricing_pr_1": "Tout ce qui est dans Performance",
  "agency_pricing_pr_2": "Gestion Google Ads",
  "agency_pricing_pr_3": "Audits de performance hebdomadaires",
  "agency_pricing_pr_4": "Gestionnaire de compte dédié",
  "agency_pricing_pr_5": "Intégrations personnalisées",
  "agency_social_title": "La confiance des entreprises locales",
  "agency_social_rista_label": "RisTA AI :",
  "agency_social_rista_quote": "J'analyse le comportement des visiteurs en temps réel pour booster vos conversions.",
  "agency_social_see_clients": "Ce que disent nos clients",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "PDG, Boutique locale",
  "agency_social_t1_text": "Nos prospects ont doublé le premier mois ! Le site charge instantanément et nos clients adorent le nouveau design.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Propriétaire de restaurant",
  "agency_social_t2_text": "Nos commandes en ligne ont augmenté de 40% après le lancement. La différence de vitesse est le jour et la nuit.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Studio de fitness",
  "agency_social_t3_text": "Professionnel, rapide et ils tiennent vraiment leurs promesses. Notre taux de réservation a augmenté de 35% en 3 semaines.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Propriétaire de boutique",
  "agency_social_t4_text": "La mise en place e-commerce était parfaite. La récupération de panier seule a rentabilisé le plan Performance au premier trimestre.",
  "agency_social_metric_1": "Temps de chargement moy.",
  "agency_social_metric_2": "Plus de prospects",
  "agency_social_metric_3": "Satisfaction client",
  "agency_services_title": "Tout ce dont votre entreprise a besoin",
  "agency_services_subtitle": "Solutions digitales complètes pour développer votre présence en ligne.",
  "agency_svc_fast_title": "Sites web rapides",
  "agency_svc_fast_desc": "Sites personnalisés chargeant en moins d'1 seconde. Mobile-first, optimisés SEO, axés conversion.",
  "agency_svc_ecom_title": "Boutiques E-Commerce",
  "agency_svc_ecom_desc": "Vendez en ligne avec récupération de panier, traitement des paiements et gestion des stocks.",
  "agency_svc_seo_title": "Audit SEO & Optimisation",
  "agency_svc_seo_desc": "Classez-vous plus haut sur Google. SEO technique, stratégie de contenu et rapports mensuels.",
  "agency_svc_ads_title": "Configuration Google Ads",
  "agency_svc_ads_desc": "Obtenez du trafic ciblé rapidement. Configuration de campagne, optimisation et suivi ROI inclus.",
  "agency_svc_maint_title": "Maintenance & Support",
  "agency_svc_maint_desc": "Hébergement, mises à jour de sécurité, sauvegardes et modifications de contenu. À partir de €30/mois.",
  "agency_faq_title": "Questions fréquentes",
  "agency_faq_q1": "Quelle sera la vitesse de chargement de mon site ?",
  "agency_faq_a1": "Moins d'1 seconde. Nous optimisons chaque milliseconde — de la réponse serveur au rendu visuel complet.",
  "agency_faq_q2": "Que comprend le forfait Starter à €498 ?",
  "agency_faq_a2": "Un site web ultra-rapide personnalisé, domaine et hébergement pour 1 an, tableau de bord analytique, design responsive et certificat SSL.",
  "agency_faq_q3": "Combien de temps faut-il pour le lancement ?",
  "agency_faq_a3": "La plupart des projets Starter sont lancés en 2-3 semaines. Les plans Performance et Premium prennent 4-6 semaines.",
  "agency_faq_q4": "Proposez-vous une maintenance continue ?",
  "agency_faq_a4": "Oui. Après la première année, la maintenance commence à €30/mois, incluant hébergement, mises à jour de sécurité et modifications mineures.",
  "agency_faq_q5": "Puis-je mettre à niveau mon plan plus tard ?",
  "agency_faq_a5": "Absolument. Vous pouvez passer de Starter à Performance ou Premium à tout moment. Nous créditerons votre investissement initial.",
  "agency_cta_title_1": "Prêt à évoluer ",
  "agency_cta_title_2": "sans limites ?",
  "agency_cta_subtitle": "Parlez-nous de votre entreprise et nous créerons un plan personnalisé. Consultation gratuite, sans engagement.",
  "agency_contact_name": "Votre nom",
  "agency_contact_email": "Adresse e-mail",
  "agency_contact_biz_select": "Type d'entreprise",
  "agency_contact_biz_restaurant": "Restaurant / Alimentation",
  "agency_contact_biz_retail": "Commerce / Boutique",
  "agency_contact_biz_services": "Services professionnels",
  "agency_contact_biz_fitness": "Fitness / Bien-être",
  "agency_contact_biz_realestate": "Immobilier",
  "agency_contact_biz_other": "Autre",
  "agency_contact_submit": "Consultation gratuite",
  "agency_contact_sent_title": "Message envoyé !",
  "agency_contact_sent_desc": "Nous vous répondrons dans les 24 heures.",
  "agency_exit_title": "Attendez ! Audit de vitesse gratuit ?",
  "agency_exit_desc": "Découvrez à quel point votre site pourrait être plus rapide. Rapport détaillé — 100% gratuit.",
  "agency_exit_email": "Votre email",
  "agency_exit_submit": "Envoyer l'audit",
  "agency_exit_thanks_title": "Merci !",
  "agency_exit_thanks_desc": "Nous vous enverrons votre audit de vitesse gratuit dans les 24 heures.",
  "agency_footer_brand_desc": "Développé, hébergé et conçu par Infinitybusiness.org",
  "agency_footer_services": "Services",
  "agency_footer_fast_web": "Sites web rapides",
  "agency_footer_ecom": "Boutiques E-Commerce",
  "agency_footer_seo": "Audit SEO",
  "agency_footer_ads": "Configuration Google Ads",
  "agency_footer_maint": "Maintenance",
  "agency_footer_company": "Entreprise",
  "agency_footer_about": "À propos",
  "agency_footer_contact": "Contact",
  "agency_footer_privacy": "Politique de confidentialité",
  "agency_footer_terms": "Conditions générales",
  "agency_footer_touch": "Nous contacter",
  "agency_footer_copyright": "© 2026 Infinity Business. Tous droits réservés.",
  "agency_footer_dev_by": "Développé, hébergé et conçu par",
  "agency_footer_newsletter": "S'abonner à la newsletter",
  "agency_footer_subscribe": "S'abonner",
  "agency_sticky_pricing": "Voir les tarifs",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Decouvrez notre portfolio de transformations web. Comparaisons avant et apres de vrais projets clients.",
  "showroom_badge": "Nos Realisations",
  "showroom_title_prefix": "Projet",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "Decouvrez de vraies transformations. Faites glisser le curseur pour comparer les etats avant et apres de nos projets clients.",
  "showroom_search_placeholder": "Rechercher des projets...",
  "showroom_all_services": "Tous les Services",
  "showroom_sort_newest": "Plus recents",
  "showroom_sort_oldest": "Plus anciens",
  "showroom_sort_name_az": "Nom A-Z",
  "showroom_sort_name_za": "Nom Z-A",
  "showroom_active_filters": "Filtres actifs",
  "showroom_showing": "Affichage",
  "showroom_project_singular": "projet",
  "showroom_project_plural": "projets",
  "showroom_empty": "Aucun projet dans le showroom pour le moment.",
  "showroom_no_match": "Aucun projet ne correspond a vos filtres.",
  "showroom_features_built": "Fonctionnalites Realisees",
  "showroom_visit_live": "Visiter le Site en Direct"
};
